const getCategoriesServiceMock = {
    code: 200,
    status: null,
    message: 'success',
    response: [
        {
            idMerchant: 1,
            isFatherMerchant: true,
            categoryList: [
                {
                    isActive: true,
                    score: 0,
                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                    hasChildren: true,
                    title: 'Elektra | Motocicletas y Accesorios',
                    fatherCategoryId: 0,
                    description: '¡Crea momentos llenos de aventura en tu nueva motocicleta! Cómprala aquí al mejor precio y recógela',
                    id: 1,
                    showInStoreFront: true,
                    showBrandFilter: false,
                    activeStoreFrontLink: true,
                    name: 'Motocicletas y Accesorios',
                    numberChildren: 7,
                    children: [
                        {
                            isActive: true,
                            score: 0,
                            stockKeepingUnitSelectionMode: 'SPECIFICATION',
                            hasChildren: true,
                            title: 'Motoneta',
                            fatherCategoryId: 1,
                            description: 'Motocicletas',
                            id: 13,
                            showInStoreFront: true,
                            showBrandFilter: false,
                            activeStoreFrontLink: false,
                            name: 'Motoneta',
                            children: [
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: '125 cc',
                                    fatherCategoryId: 13,
                                    description: '125 cc',
                                    id: 220,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: '125 cc',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: '150 cc',
                                    fatherCategoryId: 13,
                                    description: 'motos, atv, 150 cc',
                                    id: 221,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: '150 cc',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    fatherCategoryId: 13,
                                    id: 9296,
                                    showInStoreFront: false,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: false,
                                    name: '150',
                                    children: [],
                                    masterCategoryId: 0
                                }
                            ],
                            masterCategoryId: 0
                        },
                        {
                            isActive: true,
                            score: 0,
                            stockKeepingUnitSelectionMode: 'SPECIFICATION',
                            hasChildren: true,
                            title: 'Accesorios Motos',
                            fatherCategoryId: 1,
                            description: 'guantes para moto, cascos, baterias, llantas',
                            id: 14,
                            showInStoreFront: true,
                            showBrandFilter: false,
                            activeStoreFrontLink: true,
                            name: 'Accesorios Motos',
                            children: [
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Cascos',
                                    fatherCategoryId: 14,
                                    description: 'casco para moto, casco para motocicleta',
                                    id: 204,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Cascos',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: false,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Cajuela',
                                    fatherCategoryId: 14,
                                    description: 'Cajuela, Caja para moto, Kajuela, caja, caguela',
                                    id: 205,
                                    showInStoreFront: false,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: false,
                                    name: 'Cajuela',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Chaquetas',
                                    fatherCategoryId: 14,
                                    description:
                                        'Chaqueta, jacket, chaqueta, traje para moto, trajes para motos, trajes, traje, chumpa, chumpas, acce',
                                    id: 206,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Chaquetas',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Guantes',
                                    fatherCategoryId: 14,
                                    description: 'Guantes, juantes, guante para moto, juante para moto, huante, accesorios para moto',
                                    id: 207,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Guantes',
                                    children: [],
                                    masterCategoryId: 0
                                }
                            ],
                            masterCategoryId: 0
                        },
                        {
                            isActive: true,
                            score: 0,
                            stockKeepingUnitSelectionMode: 'SPECIFICATION',
                            hasChildren: true,
                            title: 'Cuatrimoto',
                            fatherCategoryId: 1,
                            description: 'ATV, Cuatrimoto',
                            id: 15,
                            showInStoreFront: true,
                            showBrandFilter: false,
                            activeStoreFrontLink: true,
                            name: 'Cuatrimoto',
                            children: [
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: '150 cc',
                                    fatherCategoryId: 15,
                                    description: '150 cc',
                                    id: 208,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: '150 cc',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: '200 cc',
                                    fatherCategoryId: 15,
                                    description: '200 cc',
                                    id: 209,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: '200 cc',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: '250 cc',
                                    fatherCategoryId: 15,
                                    description: '250 cc',
                                    id: 210,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: '250 cc',
                                    children: [],
                                    masterCategoryId: 0
                                }
                            ],
                            masterCategoryId: 0
                        },
                        {
                            isActive: true,
                            score: 0,
                            stockKeepingUnitSelectionMode: 'SPECIFICATION',
                            hasChildren: true,
                            title: 'Trabajo',
                            fatherCategoryId: 1,
                            description: 'Trabajo',
                            id: 16,
                            showInStoreFront: true,
                            showBrandFilter: false,
                            activeStoreFrontLink: true,
                            name: 'Trabajo',
                            children: [
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: '125 cc',
                                    fatherCategoryId: 16,
                                    description: '125 cc',
                                    id: 222,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: '125 cc',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: '150 cc',
                                    fatherCategoryId: 16,
                                    description: '150 cc',
                                    id: 223,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: '150 cc',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: '200 cc',
                                    fatherCategoryId: 16,
                                    description: '200 cc',
                                    id: 224,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: '200 cc',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: '110 a 115 cc',
                                    fatherCategoryId: 16,
                                    description: '110 a 115 cc',
                                    id: 225,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: '110 a 115 cc',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: false,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: '250 cc',
                                    fatherCategoryId: 16,
                                    description: '250 cc',
                                    id: 226,
                                    showInStoreFront: false,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: false,
                                    name: '250 cc',
                                    children: [],
                                    masterCategoryId: 0
                                }
                            ],
                            masterCategoryId: 0
                        },
                        {
                            isActive: true,
                            score: 0,
                            stockKeepingUnitSelectionMode: 'SPECIFICATION',
                            hasChildren: true,
                            title: 'Doble Proposito',
                            fatherCategoryId: 1,
                            description: 'Doble Proposito',
                            id: 17,
                            showInStoreFront: true,
                            showBrandFilter: false,
                            activeStoreFrontLink: true,
                            name: 'Doble Proposito',
                            children: [
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: '125 cc',
                                    fatherCategoryId: 17,
                                    description: '125 cc',
                                    id: 217,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: '125 cc',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: '150 cc',
                                    fatherCategoryId: 17,
                                    description: '150 cc',
                                    id: 218,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: '150 cc',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: '200 cc',
                                    fatherCategoryId: 17,
                                    description: '200 cc',
                                    id: 219,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: '200 cc',
                                    children: [],
                                    masterCategoryId: 0
                                }
                            ],
                            masterCategoryId: 0
                        },
                        {
                            isActive: true,
                            score: 0,
                            stockKeepingUnitSelectionMode: 'SPECIFICATION',
                            hasChildren: true,
                            title: 'Deportivas',
                            fatherCategoryId: 1,
                            description: 'Deportivas',
                            id: 18,
                            showInStoreFront: true,
                            showBrandFilter: false,
                            activeStoreFrontLink: true,
                            name: 'Deportivas',
                            children: [
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: '200 cc',
                                    fatherCategoryId: 18,
                                    description: '200 cc',
                                    id: 211,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: '200 cc',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: '250 cc',
                                    fatherCategoryId: 18,
                                    description: '250 cc',
                                    id: 212,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: '250 cc',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: false,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: '300 cc',
                                    fatherCategoryId: 18,
                                    description: '300 cc, centimetros cubicos',
                                    id: 213,
                                    showInStoreFront: false,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: false,
                                    name: '300 cc',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: '125cc',
                                    fatherCategoryId: 18,
                                    description: '125cc, deportivas, deportiva',
                                    id: 214,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: '125cc',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: false,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: '180cc',
                                    fatherCategoryId: 18,
                                    description: '180cc, 180 cc, deportivas, deportiva',
                                    id: 215,
                                    showInStoreFront: false,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: false,
                                    name: '180cc',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: '160cc',
                                    fatherCategoryId: 18,
                                    description: '160cc, 160 cc, deportivas, deportiva',
                                    id: 216,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: '160cc',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: '150 cc',
                                    fatherCategoryId: 18,
                                    description: '150 cc',
                                    id: 280,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: '150 cc',
                                    children: [],
                                    masterCategoryId: 0
                                }
                            ],
                            masterCategoryId: 0
                        },
                        {
                            isActive: true,
                            score: 0,
                            stockKeepingUnitSelectionMode: 'SPECIFICATION',
                            hasChildren: true,
                            title: 'Vehículos',
                            fatherCategoryId: 1,
                            description: 'Vehículos',
                            id: 19,
                            showInStoreFront: true,
                            showBrandFilter: false,
                            activeStoreFrontLink: true,
                            name: 'Vehículos',
                            children: [
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Tuc Tuc',
                                    fatherCategoryId: 19,
                                    description: 'Tuc Tuc',
                                    id: 227,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Tuc Tuc',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Accesorios Vehículos',
                                    fatherCategoryId: 19,
                                    description: 'Accesorios Vehículos',
                                    id: 228,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Accesorios Vehículos',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Vehículos',
                                    fatherCategoryId: 19,
                                    description: 'Vehículos',
                                    id: 281,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Vehículos',
                                    children: [],
                                    masterCategoryId: 0
                                }
                            ],
                            masterCategoryId: 0
                        }
                    ],
                    masterCategoryId: 0
                },
                {
                    isActive: true,
                    score: 0,
                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                    hasChildren: true,
                    title: 'Elektra | Camas',
                    fatherCategoryId: 0,
                    description: 'Te ofrecemos los mejores sets de camas para que descanses como mereces. ¡Compra al mejor precio en E',
                    id: 2,
                    showInStoreFront: true,
                    showBrandFilter: false,
                    activeStoreFrontLink: true,
                    name: 'Camas',
                    numberChildren: 3,
                    children: [
                        {
                            isActive: true,
                            score: 0,
                            stockKeepingUnitSelectionMode: 'SPECIFICATION',
                            hasChildren: true,
                            title: 'Colchones y Boxes',
                            fatherCategoryId: 2,
                            description: 'Colchones, boxes, hogar, camas',
                            id: 20,
                            showInStoreFront: true,
                            showBrandFilter: false,
                            activeStoreFrontLink: true,
                            name: 'Colchones',
                            children: [
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Colchones Individuales',
                                    fatherCategoryId: 20,
                                    description: 'Colchon, colchones, individual, individuales',
                                    id: 73,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Individuales',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Colchon Matrimonial',
                                    fatherCategoryId: 20,
                                    description: 'Colchon, colchones, matrimonial, matrimoniales',
                                    id: 74,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Matrimoniales',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: false,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Queen Size',
                                    fatherCategoryId: 20,
                                    description: 'Queen Size',
                                    id: 75,
                                    showInStoreFront: false,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: false,
                                    name: 'Queen Size',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: false,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'King Size',
                                    fatherCategoryId: 20,
                                    description: 'King Size',
                                    id: 76,
                                    showInStoreFront: false,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: false,
                                    name: 'King Size',
                                    children: [],
                                    masterCategoryId: 0
                                }
                            ],
                            masterCategoryId: 0
                        },
                        {
                            isActive: true,
                            score: 0,
                            stockKeepingUnitSelectionMode: 'SPECIFICATION',
                            hasChildren: true,
                            title: 'Blancos',
                            fatherCategoryId: 2,
                            description: 'blancos, sabanas, almohadas',
                            id: 21,
                            showInStoreFront: true,
                            showBrandFilter: false,
                            activeStoreFrontLink: true,
                            name: 'Blancos',
                            children: [
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Almohadas',
                                    fatherCategoryId: 21,
                                    description: 'Almohadas',
                                    id: 69,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Almohadas',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Sabanas',
                                    fatherCategoryId: 21,
                                    description: 'Sabanas, ropa de cama',
                                    id: 70,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Sabanas',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Blancos, ropa de cama,Edredones',
                                    fatherCategoryId: 21,
                                    description: 'Blancos, ropa de cama,Edredones',
                                    id: 71,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Edredones',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Protector para Colchon',
                                    fatherCategoryId: 21,
                                    description: 'Protector para Colchon',
                                    id: 72,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Protector para Colchon',
                                    children: [],
                                    masterCategoryId: 0
                                }
                            ],
                            masterCategoryId: 0
                        },
                        {
                            isActive: true,
                            score: 0,
                            stockKeepingUnitSelectionMode: 'SPECIFICATION',
                            hasChildren: true,
                            title: 'Set de Camas',
                            fatherCategoryId: 2,
                            description: 'set de cama, sabanas, colchones',
                            id: 22,
                            showInStoreFront: true,
                            showBrandFilter: false,
                            activeStoreFrontLink: true,
                            name: 'Set de Camas',
                            children: [
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Set de Cama Individual',
                                    fatherCategoryId: 22,
                                    description: 'set de cama individual, set de camas individuales',
                                    id: 77,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Individuales',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Set de Cama Matrimonial',
                                    fatherCategoryId: 22,
                                    description: 'set de cama matrimonial, set de camas matrimoniales',
                                    id: 78,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Matrimoniales',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Set de Cama Queen Size',
                                    fatherCategoryId: 22,
                                    description: 'set de cama queen, set de camas queen',
                                    id: 79,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Queen Size',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Set de Cama King Size',
                                    fatherCategoryId: 22,
                                    description: 'set de cama king size, set de camas king size',
                                    id: 80,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'King Size',
                                    children: [],
                                    masterCategoryId: 0
                                }
                            ],
                            masterCategoryId: 0
                        }
                    ],
                    masterCategoryId: 0
                },
                {
                    isActive: true,
                    score: 0,
                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                    hasChildren: true,
                    title: 'Elektra | Cómputo',
                    fatherCategoryId: 0,
                    description: '¡Aprovecha las mejores ofertas en Elektra.com.gt! Ingresa aquí y actualízate con la mejor tecnología',
                    id: 3,
                    showInStoreFront: true,
                    showBrandFilter: false,
                    activeStoreFrontLink: true,
                    name: 'Cómputo',
                    numberChildren: 6,
                    children: [
                        {
                            isActive: true,
                            score: 0,
                            stockKeepingUnitSelectionMode: 'SPECIFICATION',
                            hasChildren: true,
                            title: 'Accesorios computo, accesorios computo, computadoras',
                            fatherCategoryId: 3,
                            description: 'Accesorios computo, accesorios computo, computadoras',
                            id: 23,
                            showInStoreFront: true,
                            showBrandFilter: false,
                            activeStoreFrontLink: true,
                            name: 'Accesorios Cómputo',
                            children: [
                                {
                                    isActive: false,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Pantallas para Proyección',
                                    fatherCategoryId: 23,
                                    description: 'Pantallas para Proyección',
                                    id: 81,
                                    showInStoreFront: false,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: false,
                                    name: 'Pantallas para Proyección',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Redes',
                                    fatherCategoryId: 23,
                                    description: 'Redes',
                                    id: 82,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Redes',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Hardware',
                                    fatherCategoryId: 23,
                                    description: 'Hardware',
                                    id: 83,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Hardware',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: false,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Headsets',
                                    fatherCategoryId: 23,
                                    description: 'Headsets, audifonos, audifonos para computo break',
                                    id: 84,
                                    showInStoreFront: false,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: false,
                                    name: 'Headsets',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: false,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Cartuchos de Impresión',
                                    fatherCategoryId: 23,
                                    description: 'Cartuchos de Impresión',
                                    id: 86,
                                    showInStoreFront: false,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: false,
                                    name: 'Cartuchos de Impresión',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'UPS y Reguladores',
                                    fatherCategoryId: 23,
                                    description: 'UPS y Reguladores',
                                    id: 87,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'UPS y Reguladores',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Software',
                                    fatherCategoryId: 23,
                                    description: 'Software',
                                    id: 88,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Software',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Memorias',
                                    fatherCategoryId: 23,
                                    description: 'Memorias',
                                    id: 89,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: false,
                                    name: 'Memorias',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Mochilas',
                                    fatherCategoryId: 23,
                                    description: 'Mochilas',
                                    id: 90,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Mochilas',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Mouse',
                                    fatherCategoryId: 23,
                                    description: 'Mouse',
                                    id: 91,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Mouse',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Teclados',
                                    fatherCategoryId: 23,
                                    description: 'Teclados',
                                    id: 92,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Teclados',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Camaras Web',
                                    fatherCategoryId: 23,
                                    description: 'Camaras Web',
                                    id: 93,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Camaras Web',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Accesorios',
                                    fatherCategoryId: 23,
                                    description: 'Accesorios computo',
                                    id: 105,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Accesorios',
                                    children: [],
                                    masterCategoryId: 0
                                }
                            ],
                            masterCategoryId: 0
                        },
                        {
                            isActive: false,
                            score: 0,
                            stockKeepingUnitSelectionMode: 'SPECIFICATION',
                            hasChildren: true,
                            title: 'Accesorios e Insumos',
                            fatherCategoryId: 3,
                            description: 'Accesorios, insumos, cartuchos de tinta, impresoras, tintas',
                            id: 24,
                            showInStoreFront: false,
                            showBrandFilter: false,
                            activeStoreFrontLink: false,
                            name: 'Accesorios e Insumos',
                            children: [
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Accesorios e Insumos',
                                    fatherCategoryId: 24,
                                    description: 'Insumos, impresoras, tinta, tintas, cartuchos',
                                    id: 106,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Accesorios e Insumos',
                                    children: [],
                                    masterCategoryId: 0
                                }
                            ],
                            masterCategoryId: 0
                        },
                        {
                            isActive: true,
                            score: 0,
                            stockKeepingUnitSelectionMode: 'SPECIFICATION',
                            hasChildren: true,
                            title: 'Computadoras',
                            fatherCategoryId: 3,
                            description: 'Computadoras, cómputo',
                            id: 25,
                            showInStoreFront: true,
                            showBrandFilter: false,
                            activeStoreFrontLink: true,
                            name: 'Computadoras',
                            children: [
                                {
                                    isActive: false,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Desktop',
                                    fatherCategoryId: 25,
                                    description: 'Desktop, escritorio',
                                    id: 94,
                                    showInStoreFront: false,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: false,
                                    name: 'Desktop',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Laptop',
                                    fatherCategoryId: 25,
                                    description: 'Laptops, portatiles',
                                    id: 95,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Laptop',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Todo en Uno',
                                    fatherCategoryId: 25,
                                    description: 'computadoras, todo en uno',
                                    id: 96,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Todo en Uno',
                                    children: [],
                                    masterCategoryId: 0
                                }
                            ],
                            masterCategoryId: 0
                        },
                        {
                            isActive: true,
                            score: 0,
                            stockKeepingUnitSelectionMode: 'SPECIFICATION',
                            hasChildren: true,
                            title: 'Periféricos',
                            fatherCategoryId: 3,
                            description: 'Periféricos, computo, computadoras, impresoras, impresion',
                            id: 26,
                            showInStoreFront: true,
                            showBrandFilter: false,
                            activeStoreFrontLink: true,
                            name: 'Periféricos',
                            children: [
                                {
                                    isActive: false,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Impresoras',
                                    fatherCategoryId: 26,
                                    description: 'Impresion, impresoras',
                                    id: 100,
                                    showInStoreFront: false,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: false,
                                    name: 'Impresoras',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Impresoras y Multifuncionales',
                                    fatherCategoryId: 26,
                                    description: 'Multifuncional, impresora, scanner, escaner, digital',
                                    id: 101,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Impresoras y Multifuncionales',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Proyector',
                                    fatherCategoryId: 26,
                                    description: 'Proyectores, proyeccion',
                                    id: 102,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Proyector',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Monitores',
                                    fatherCategoryId: 26,
                                    description: 'Monitores',
                                    id: 103,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Monitores',
                                    children: [],
                                    masterCategoryId: 0
                                }
                            ],
                            masterCategoryId: 0
                        },
                        {
                            isActive: true,
                            score: 0,
                            stockKeepingUnitSelectionMode: 'SPECIFICATION',
                            hasChildren: true,
                            title: 'Tablets',
                            fatherCategoryId: 3,
                            description: 'Tablets, apple, ipad',
                            id: 27,
                            showInStoreFront: true,
                            showBrandFilter: false,
                            activeStoreFrontLink: true,
                            name: 'Tablets',
                            children: [
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Tablets',
                                    fatherCategoryId: 27,
                                    description: 'Tablets, apple, ipad',
                                    id: 108,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Tablets',
                                    children: [],
                                    masterCategoryId: 0
                                }
                            ],
                            masterCategoryId: 0
                        },
                        {
                            isActive: true,
                            score: 0,
                            stockKeepingUnitSelectionMode: 'SPECIFICATION',
                            hasChildren: true,
                            title: 'Gaming',
                            fatherCategoryId: 3,
                            description: 'Gaming',
                            id: 28,
                            showInStoreFront: true,
                            showBrandFilter: false,
                            activeStoreFrontLink: true,
                            name: 'Gaming',
                            children: [
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Sillas',
                                    fatherCategoryId: 28,
                                    description: 'Sillas',
                                    id: 97,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Sillas',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Teclados',
                                    fatherCategoryId: 28,
                                    description: 'Teclados',
                                    id: 98,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Teclados',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Mouse',
                                    fatherCategoryId: 28,
                                    description: 'Mouse',
                                    id: 99,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Mouse',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Audífonos',
                                    fatherCategoryId: 28,
                                    description: 'Audífonos',
                                    id: 107,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Audífonos',
                                    children: [],
                                    masterCategoryId: 0
                                }
                            ],
                            masterCategoryId: 0
                        }
                    ],
                    masterCategoryId: 0
                },
                {
                    isActive: true,
                    score: 0,
                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                    hasChildren: true,
                    title: 'Elektra | Electrónica',
                    fatherCategoryId: 0,
                    description: '¡En Elektra.com.gt encuentras siempre la mejor tecnología! Cómprala aquí de manera fácil y segura.',
                    id: 4,
                    showInStoreFront: true,
                    showBrandFilter: false,
                    activeStoreFrontLink: true,
                    name: 'Electrónica',
                    numberChildren: 7,
                    children: [
                        {
                            isActive: true,
                            score: 0,
                            stockKeepingUnitSelectionMode: 'SPECIFICATION',
                            hasChildren: true,
                            title: 'Accesorios',
                            fatherCategoryId: 4,
                            description: 'accesorios de electrónica',
                            id: 29,
                            showInStoreFront: true,
                            showBrandFilter: false,
                            activeStoreFrontLink: true,
                            name: 'Accesorios',
                            children: [
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Casa Inteligente',
                                    fatherCategoryId: 29,
                                    description: 'Casa Inteligente',
                                    id: 136,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Casa Inteligente',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Bases para Tv y Pantallas',
                                    fatherCategoryId: 29,
                                    description: 'Bases para tv, bases para pantallas, soportes',
                                    id: 137,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Bases para Tv y Pantallas',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Radiograbadoras',
                                    fatherCategoryId: 29,
                                    description: 'Radiograbadoras, radiograbadora, radiogravadoras, radiogravadora',
                                    id: 138,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Radiograbadoras',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Adaptadores y Cargadores',
                                    fatherCategoryId: 29,
                                    description: 'Adaptadores y Cargadores',
                                    id: 139,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Adaptadores y Cargadores',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Accesorios',
                                    fatherCategoryId: 29,
                                    description: 'Accesorios',
                                    id: 273,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Accesorios',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Bocinas',
                                    fatherCategoryId: 29,
                                    description: 'Bocinas',
                                    id: 274,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Bocinas',
                                    children: [],
                                    masterCategoryId: 0
                                }
                            ],
                            masterCategoryId: 0
                        },
                        {
                            isActive: true,
                            score: 0,
                            stockKeepingUnitSelectionMode: 'SPECIFICATION',
                            hasChildren: true,
                            title: 'Audio para Autos',
                            fatherCategoryId: 4,
                            description: 'Audio para el auto, autoestereos, audio',
                            id: 30,
                            showInStoreFront: true,
                            showBrandFilter: false,
                            activeStoreFrontLink: true,
                            name: 'Audio para Autos',
                            children: [
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Autoestéreos Y Accesorios',
                                    fatherCategoryId: 30,
                                    description: 'Autoestéreos Y Accesorios, audio para el auto',
                                    id: 140,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Autoestéreos Y Accesorios',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Bocinas para Carro',
                                    fatherCategoryId: 30,
                                    description: 'Bocinas para Carro',
                                    id: 141,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Bocinas para Carro',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Subwoofer',
                                    fatherCategoryId: 30,
                                    description: 'Subwoofer',
                                    id: 142,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Subwoofer',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: false,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Amplificadores',
                                    fatherCategoryId: 30,
                                    description: 'Amplificadores',
                                    id: 143,
                                    showInStoreFront: false,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: false,
                                    name: 'Amplificadores',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: false,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Tweeters',
                                    fatherCategoryId: 30,
                                    description: 'Tweeters',
                                    id: 144,
                                    showInStoreFront: false,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: false,
                                    name: 'Tweeters',
                                    children: [],
                                    masterCategoryId: 0
                                }
                            ],
                            masterCategoryId: 0
                        },
                        {
                            isActive: true,
                            score: 0,
                            stockKeepingUnitSelectionMode: 'SPECIFICATION',
                            hasChildren: true,
                            title: 'Audio y Equipos de Sonido',
                            fatherCategoryId: 4,
                            description: 'Audio para hogar, audio hogar, bocinas, Audio y Equipos de Sonido',
                            id: 31,
                            showInStoreFront: true,
                            showBrandFilter: false,
                            activeStoreFrontLink: true,
                            name: 'Equipos de Sonido',
                            children: [
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Equipo de Sonido',
                                    fatherCategoryId: 31,
                                    description: 'Audio para hogar, audio hogar, bocinas, cierra calles, sonideros',
                                    id: 149,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Equipo de Sonido',
                                    children: [],
                                    masterCategoryId: 0
                                }
                            ],
                            masterCategoryId: 0
                        },
                        {
                            isActive: true,
                            score: 0,
                            stockKeepingUnitSelectionMode: 'SPECIFICATION',
                            hasChildren: true,
                            title: 'Televisores',
                            fatherCategoryId: 4,
                            description: 'Televisor, televisiones, teles, tv, pantallas',
                            id: 32,
                            showInStoreFront: true,
                            showBrandFilter: false,
                            activeStoreFrontLink: true,
                            name: 'Televisores',
                            children: [
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'LED',
                                    fatherCategoryId: 32,
                                    description: 'Pantallas Led, led, televisiones, teles, tv',
                                    id: 150,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'LED',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Smart TV',
                                    fatherCategoryId: 32,
                                    description: 'Pantallas smart, smart, televisiones, teles, tv',
                                    id: 151,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Smart TV',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: '4K-UHD',
                                    fatherCategoryId: 32,
                                    description: '4K-UHD, Televisor 4k, 4k, UHD, tv',
                                    id: 152,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: '4K-UHD',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'QLED',
                                    fatherCategoryId: 32,
                                    description: 'pantallas qled, qled, televisores qled, tv qled',
                                    id: 153,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'QLED',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'OLED',
                                    fatherCategoryId: 32,
                                    description: 'televisor oled, oled, tv oled, televisores oled',
                                    id: 154,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'OLED',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Proyectores',
                                    fatherCategoryId: 32,
                                    description: 'Proyectores',
                                    id: 155,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Proyectores',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: '8K-UHD',
                                    fatherCategoryId: 32,
                                    description: '8K-UHD',
                                    id: 156,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: '8K-UHD',
                                    children: [],
                                    masterCategoryId: 0
                                }
                            ],
                            masterCategoryId: 0
                        },
                        {
                            isActive: true,
                            score: 0,
                            stockKeepingUnitSelectionMode: 'SPECIFICATION',
                            hasChildren: true,
                            title: 'Video',
                            fatherCategoryId: 4,
                            description: 'Video, videos, digital',
                            id: 33,
                            showInStoreFront: true,
                            showBrandFilter: false,
                            activeStoreFrontLink: true,
                            name: 'Audio y Video para TV',
                            children: [
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Barra de Sonido',
                                    fatherCategoryId: 33,
                                    description: 'Barra de Sonido',
                                    id: 145,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Barra de Sonido',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Teatro en Casa',
                                    fatherCategoryId: 33,
                                    description: 'Teatro en Casa',
                                    id: 146,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Teatro en Casa',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'DVD',
                                    fatherCategoryId: 33,
                                    description: 'DVD',
                                    id: 147,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'DVD',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: false,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'BluRay',
                                    fatherCategoryId: 33,
                                    description: 'BluRay',
                                    id: 148,
                                    showInStoreFront: false,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: false,
                                    name: 'BluRay',
                                    children: [],
                                    masterCategoryId: 0
                                }
                            ],
                            masterCategoryId: 0
                        },
                        {
                            isActive: true,
                            score: 0,
                            stockKeepingUnitSelectionMode: 'SPECIFICATION',
                            hasChildren: true,
                            title: 'Videojuegos',
                            fatherCategoryId: 4,
                            description: 'Videojuegos, consolas, xbox, playstation, nintendo, switch, juegos, juguetes',
                            id: 34,
                            showInStoreFront: true,
                            showBrandFilter: false,
                            activeStoreFrontLink: true,
                            name: 'Videojuegos',
                            children: [
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Consolas',
                                    fatherCategoryId: 34,
                                    description: 'Videojuegos, consolas, xbox, playstation, nintendo, switch, juegos, juguetes',
                                    id: 157,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Consolas',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Juegos',
                                    fatherCategoryId: 34,
                                    description: 'Videojuegos, consolas, xbox, playstation, nintendo, switch, juegos, juguetes',
                                    id: 158,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Juegos',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Accesorios',
                                    fatherCategoryId: 34,
                                    description: 'Accesorios',
                                    id: 275,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Accesorios',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Contenido Digital',
                                    fatherCategoryId: 34,
                                    description: 'Contenido Digital',
                                    id: 276,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Contenido Digital',
                                    children: [],
                                    masterCategoryId: 0
                                }
                            ],
                            masterCategoryId: 0
                        },
                        {
                            isActive: true,
                            score: 0,
                            stockKeepingUnitSelectionMode: 'SPECIFICATION',
                            hasChildren: true,
                            title: 'Cámaras',
                            fatherCategoryId: 4,
                            description: 'Cámaras',
                            id: 110,
                            showInStoreFront: true,
                            showBrandFilter: false,
                            activeStoreFrontLink: true,
                            name: 'Cámaras',
                            children: [
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Cámaras Profesionales',
                                    fatherCategoryId: 110,
                                    description: 'Cámaras Profesionales',
                                    id: 111,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Cámaras Profesionales',
                                    children: [],
                                    masterCategoryId: 0
                                }
                            ],
                            masterCategoryId: 0
                        }
                    ],
                    masterCategoryId: 0
                },
                {
                    isActive: true,
                    score: 0,
                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                    hasChildren: true,
                    title: 'Elektra | Línea Blanca',
                    fatherCategoryId: 0,
                    description: 'Haz más fáciles tus actividades diarias con los mejores productos de línea blanca. ¡Cómpralos en Ele',
                    id: 5,
                    showInStoreFront: true,
                    showBrandFilter: false,
                    activeStoreFrontLink: true,
                    name: 'Línea Blanca',
                    numberChildren: 4,
                    children: [
                        {
                            isActive: true,
                            score: 0,
                            stockKeepingUnitSelectionMode: 'SPECIFICATION',
                            hasChildren: true,
                            title: 'Aires Acondicionados y Ventiladores',
                            fatherCategoryId: 5,
                            description: 'Aires Acondicionados y Ventiladores, aires, climas',
                            id: 35,
                            showInStoreFront: true,
                            showBrandFilter: false,
                            activeStoreFrontLink: true,
                            name: 'Aires Acondicionados y Ventiladores',
                            children: [
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Elektra |Purificadores de Aire',
                                    fatherCategoryId: 35,
                                    description: 'purificador de aire, aires, purifikador, purifikadores',
                                    id: 177,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Purificadores de Aire',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: false,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Enfriadores',
                                    fatherCategoryId: 35,
                                    description: 'Aires Acondicionados y Ventiladores, aires, climas, enfriadores',
                                    id: 178,
                                    showInStoreFront: false,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: false,
                                    name: 'Enfriadores',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Mini Split',
                                    fatherCategoryId: 35,
                                    description: 'Aires Acondicionados y Ventiladores, aires, climas, minisplit, mini split',
                                    id: 179,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Mini Splits',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Ventiladores',
                                    fatherCategoryId: 35,
                                    description: 'Aires Acondicionados y Ventiladores, aires, climas, ventiladores',
                                    id: 180,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Ventiladores',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Deshumidificadores',
                                    fatherCategoryId: 35,
                                    description: 'Deshumidificadores, deshumificador, dehumifikador, dehuificador, dezhumificador',
                                    id: 181,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Deshumidificadores',
                                    children: [],
                                    masterCategoryId: 0
                                }
                            ],
                            masterCategoryId: 0
                        },
                        {
                            isActive: true,
                            score: 0,
                            stockKeepingUnitSelectionMode: 'SPECIFICATION',
                            hasChildren: true,
                            title: 'Cocina',
                            fatherCategoryId: 5,
                            description: 'Estufas, hornos, hornillos, Cocina',
                            id: 36,
                            showInStoreFront: true,
                            showBrandFilter: false,
                            activeStoreFrontLink: true,
                            name: 'Cocina',
                            children: [
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Accesorios de Cocina',
                                    fatherCategoryId: 36,
                                    description: 'Accesorios de cocina, estufas, hornos',
                                    id: 182,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Accesorios de Cocina',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Campanas y Extractores',
                                    fatherCategoryId: 36,
                                    description: 'campana, hornos, Campanas y Extractores',
                                    id: 183,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Campanas y Extractores',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: false,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Estufas de Empotrar',
                                    fatherCategoryId: 36,
                                    description: 'estufas de empotrar, estufas, estufa',
                                    id: 184,
                                    showInStoreFront: false,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: false,
                                    name: 'Estufas de Empotrar',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Estufas de Gas',
                                    fatherCategoryId: 36,
                                    description: 'Estufas de piso, horno, hornos, Estufas de Gas, estufa de gas',
                                    id: 185,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Estufas de Gas',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Estufas Industriales',
                                    fatherCategoryId: 36,
                                    description: 'Estufa industrial, cocinas, restaurante',
                                    id: 186,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Estufas Industriales',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Hornos Empotrables',
                                    fatherCategoryId: 36,
                                    description: 'Hornos, horno, horno eléctricos',
                                    id: 187,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Hornos Empotrables',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Parrillas Eléctricas',
                                    fatherCategoryId: 36,
                                    description: 'Parrillas Eléctricas, parrillas electricas , electrica, eléctricas',
                                    id: 188,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Parrillas Eléctricas',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Estufas Eléctricas',
                                    fatherCategoryId: 36,
                                    description: 'estufa, estufas,  estufa electrica, estufas electricas, estufa eléctrica',
                                    id: 189,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Estufas Eléctricas',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Cooktops',
                                    fatherCategoryId: 36,
                                    description:
                                        'Parrillas, mesas eléctricas, parrillas eléctricas, Cooktops eléctricos, Cooktop, de gas, cooktop de',
                                    id: 190,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Cooktops',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Elektra | Lavaplatos',
                                    fatherCategoryId: 36,
                                    description: 'lava platos, platoslava, labaplatos, lavadora de platos, labadora de platos',
                                    id: 191,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Lavaplatos',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Parrillas de Gas',
                                    fatherCategoryId: 36,
                                    description: 'Parrillas de Gas, parrilla gas, gas',
                                    id: 192,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Parrillas de Gas',
                                    children: [],
                                    masterCategoryId: 0
                                }
                            ],
                            masterCategoryId: 0
                        },
                        {
                            isActive: true,
                            score: 0,
                            stockKeepingUnitSelectionMode: 'SPECIFICATION',
                            hasChildren: true,
                            title: 'Lavandería',
                            fatherCategoryId: 5,
                            description: 'Lavanderia',
                            id: 37,
                            showInStoreFront: true,
                            showBrandFilter: false,
                            activeStoreFrontLink: true,
                            name: 'Lavandería',
                            children: [
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Lavadoras',
                                    fatherCategoryId: 37,
                                    description: 'Automatica carga superior, Lavadoras',
                                    id: 193,
                                    showInStoreFront: true,
                                    showBrandFilter: true,
                                    activeStoreFrontLink: true,
                                    name: 'Lavadoras',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Centros de Lavado',
                                    fatherCategoryId: 37,
                                    description: 'Centros de Lavado, lavadoras, secadora',
                                    id: 194,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Centros de Lavado',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Secadoras',
                                    fatherCategoryId: 37,
                                    description: 'Secadoras',
                                    id: 195,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Secadoras',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Accesorios',
                                    fatherCategoryId: 37,
                                    description: 'Accesorios',
                                    id: 278,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Accesorios',
                                    children: [],
                                    masterCategoryId: 0
                                }
                            ],
                            masterCategoryId: 0
                        },
                        {
                            isActive: true,
                            score: 0,
                            stockKeepingUnitSelectionMode: 'SPECIFICATION',
                            hasChildren: true,
                            title: 'Refrigeración',
                            fatherCategoryId: 5,
                            description: 'Refris, refrigeradores, congeladores, duplex, cocina',
                            id: 38,
                            showInStoreFront: true,
                            showBrandFilter: false,
                            activeStoreFrontLink: true,
                            name: 'Refrigeración',
                            children: [
                                {
                                    isActive: false,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Refrigeradores No Frost',
                                    fatherCategoryId: 38,
                                    description: 'Refrigeradores, refris, congelador inferior, Refrigeradores No Frost',
                                    id: 196,
                                    showInStoreFront: false,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: false,
                                    name: 'Refrigeradores No Frost',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: false,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Refrigeradoras Frost',
                                    fatherCategoryId: 38,
                                    description: 'Congelador superior, refrigeradores, congeladores, Refrigeradoras Frost',
                                    id: 197,
                                    showInStoreFront: false,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: false,
                                    name: 'Refrigeradores Frost',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Congeladores',
                                    fatherCategoryId: 38,
                                    description: 'Congeladores, congelador',
                                    id: 198,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Congeladores',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: false,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Side By Side y French Door',
                                    fatherCategoryId: 38,
                                    description: 'Duplex -Side By Side, refrigeradores, refris, Side By Side y French Door',
                                    id: 199,
                                    showInStoreFront: false,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: false,
                                    name: 'Side By Side y French Door',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Enfriador',
                                    fatherCategoryId: 38,
                                    description: 'Enfriador, refris, refrigeradores, enfriar',
                                    id: 200,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Enfriador',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Frigobares',
                                    fatherCategoryId: 38,
                                    description: 'Frigobares, refris, refrigeradores',
                                    id: 201,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Frigobares',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: false,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Manuales',
                                    fatherCategoryId: 38,
                                    description: 'Manuales',
                                    id: 202,
                                    showInStoreFront: false,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: false,
                                    name: 'Manuales Semi',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Refrigeradoras',
                                    fatherCategoryId: 38,
                                    description: 'Refrigeradoras,Refrigeradores No Frost,Refrigeradores Frost,Side by Side, French Door',
                                    id: 203,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Refrigeradoras',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Accesorios',
                                    fatherCategoryId: 38,
                                    description: '',
                                    id: 279,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Accesorios',
                                    children: [],
                                    masterCategoryId: 0
                                }
                            ],
                            masterCategoryId: 0
                        }
                    ],
                    masterCategoryId: 0
                },
                {
                    isActive: true,
                    score: 0,
                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                    hasChildren: true,
                    title: 'Elektra | Muebles',
                    fatherCategoryId: 0,
                    description: 'Equipa tu hogar con el mejor estilo y los mejores muebles. ¡Adquiérelos al mejor precio en Elektra o',
                    id: 6,
                    showInStoreFront: true,
                    showBrandFilter: false,
                    activeStoreFrontLink: true,
                    name: 'Muebles',
                    numberChildren: 4,
                    children: [
                        {
                            isActive: true,
                            score: 0,
                            stockKeepingUnitSelectionMode: 'SPECIFICATION',
                            hasChildren: true,
                            title: 'Muebles de Cocina',
                            fatherCategoryId: 6,
                            description: 'Alacenas, cocinas, comedores, cocina',
                            id: 39,
                            showInStoreFront: true,
                            showBrandFilter: false,
                            activeStoreFrontLink: true,
                            name: 'Muebles de Cocina',
                            children: [
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Alacenas',
                                    fatherCategoryId: 39,
                                    description: 'Alacenas',
                                    id: 234,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Alacenas',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Cocinas',
                                    fatherCategoryId: 39,
                                    description: 'Cocinas',
                                    id: 235,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Cocinas',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Comedores',
                                    fatherCategoryId: 39,
                                    description: 'Comedores, sillas, comedor, hogar',
                                    id: 236,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Comedores',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: false,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Piezas Sueltas Comedores',
                                    fatherCategoryId: 39,
                                    description: 'Piezas Sueltas Comedores, colchones, comedores',
                                    id: 237,
                                    showInStoreFront: false,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: false,
                                    name: 'Piezas Sueltas Comedores',
                                    children: [],
                                    masterCategoryId: 0
                                }
                            ],
                            masterCategoryId: 0
                        },
                        {
                            isActive: true,
                            score: 0,
                            stockKeepingUnitSelectionMode: 'SPECIFICATION',
                            hasChildren: true,
                            title: 'Dormitorio',
                            fatherCategoryId: 6,
                            description: 'Dormitorio, cuarto',
                            id: 40,
                            showInStoreFront: true,
                            showBrandFilter: false,
                            activeStoreFrontLink: true,
                            name: 'Dormitorio',
                            children: [
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Literas',
                                    fatherCategoryId: 40,
                                    description: 'Literas, cuarto, cuarto de niños',
                                    id: 229,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Literas',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Piezas Sueltas Recámaras',
                                    fatherCategoryId: 40,
                                    description: 'Piezas Sueltas Recámaras',
                                    id: 230,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Piezas Sueltas Recámaras',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Recámaras',
                                    fatherCategoryId: 40,
                                    description: 'Recámaras',
                                    id: 231,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Recámaras',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Roperos',
                                    fatherCategoryId: 40,
                                    description: 'Ropero, mueble para ropa, muebles para sala, muebles para estancia',
                                    id: 232,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Roperos',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Cómodas',
                                    fatherCategoryId: 40,
                                    description: 'Cómodas',
                                    id: 233,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Cómodas',
                                    children: [],
                                    masterCategoryId: 0
                                }
                            ],
                            masterCategoryId: 0
                        },
                        {
                            isActive: true,
                            score: 0,
                            stockKeepingUnitSelectionMode: 'SPECIFICATION',
                            hasChildren: true,
                            title: 'Sala',
                            fatherCategoryId: 6,
                            description: 'Salas Y Tapizados',
                            id: 41,
                            showInStoreFront: true,
                            showBrandFilter: false,
                            activeStoreFrontLink: true,
                            name: 'Sala',
                            children: [
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Centros de Entretenimiento',
                                    fatherCategoryId: 41,
                                    description:
                                        'Cuarto de tele, cuarto de tv, consolas de videojuegos, consolas, pantallas, base para pantalla',
                                    id: 241,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Centros de Entretenimiento',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: false,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Mesa de Centro',
                                    fatherCategoryId: 41,
                                    description: 'Juegos De Mesa, ajedrez, backgammon, diversion, juegos,Mesa de Centro',
                                    id: 242,
                                    showInStoreFront: false,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: false,
                                    name: 'Mesa de Centro',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: false,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Piezas Sueltas',
                                    fatherCategoryId: 41,
                                    description: 'Piezas Sueltas',
                                    id: 243,
                                    showInStoreFront: false,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: false,
                                    name: 'Piezas Sueltas',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: false,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Reclinables',
                                    fatherCategoryId: 41,
                                    description: 'Reclinables, sillones, muebles reclinables',
                                    id: 244,
                                    showInStoreFront: false,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: false,
                                    name: 'Reclinables',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Salas',
                                    fatherCategoryId: 41,
                                    description: 'Salas',
                                    id: 245,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Salas',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Sofás',
                                    fatherCategoryId: 41,
                                    description: 'Sofás',
                                    id: 246,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Sofás',
                                    children: [],
                                    masterCategoryId: 0
                                }
                            ],
                            masterCategoryId: 0
                        },
                        {
                            isActive: true,
                            score: 0,
                            stockKeepingUnitSelectionMode: 'SPECIFICATION',
                            hasChildren: true,
                            title: 'Muebles Plásticos',
                            fatherCategoryId: 6,
                            description: 'Muebles Plásticos',
                            id: 42,
                            showInStoreFront: true,
                            showBrandFilter: false,
                            activeStoreFrontLink: true,
                            name: 'Muebles Plásticos',
                            children: [
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Roperos',
                                    fatherCategoryId: 42,
                                    description: 'Roperos',
                                    id: 238,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Roperos',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Gabinetes',
                                    fatherCategoryId: 42,
                                    description: 'Gabinetes',
                                    id: 239,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Gabinetes',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Gaveteros',
                                    fatherCategoryId: 42,
                                    description: 'Gaveteros',
                                    id: 240,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Gaveteros',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Sillas',
                                    fatherCategoryId: 42,
                                    description: 'Sillas',
                                    id: 282,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Sillas',
                                    children: [],
                                    masterCategoryId: 0
                                }
                            ],
                            masterCategoryId: 0
                        }
                    ],
                    masterCategoryId: 0
                },
                {
                    isActive: true,
                    score: 0,
                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                    hasChildren: true,
                    title: 'Elektra | Telefonía',
                    fatherCategoryId: 0,
                    description: '¡Smartualízate en Elektra.com.gt! Encuentra aquí el teléfono que necesitas a un precio que no podrás',
                    id: 7,
                    showInStoreFront: true,
                    showBrandFilter: false,
                    activeStoreFrontLink: true,
                    name: 'Telefonía',
                    numberChildren: 6,
                    children: [
                        {
                            isActive: true,
                            score: 0,
                            stockKeepingUnitSelectionMode: 'SPECIFICATION',
                            hasChildren: true,
                            title: 'Audífonos',
                            fatherCategoryId: 7,
                            description:
                                'Audífonos, Audio personal, audio, bluetooth, manos libres, hands Free, handsfree, alambricos, inalam',
                            id: 43,
                            showInStoreFront: true,
                            showBrandFilter: false,
                            activeStoreFrontLink: true,
                            name: 'Audífonos',
                            children: [
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Inalámbricos',
                                    fatherCategoryId: 43,
                                    description: 'Inalámbrico, bluetooth, conexion bluetoot, conexion, coneccion, inalambrico',
                                    id: 248,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Inalámbricos',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Alámbricos',
                                    fatherCategoryId: 43,
                                    description: 'Audifonos alambricos,  alambricos, coneccion alambrica, audifonos con cable',
                                    id: 249,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Alámbricos',
                                    children: [],
                                    masterCategoryId: 0
                                }
                            ],
                            masterCategoryId: 0
                        },
                        {
                            isActive: true,
                            score: 0,
                            stockKeepingUnitSelectionMode: 'SPECIFICATION',
                            hasChildren: true,
                            title: 'Accesorios',
                            fatherCategoryId: 7,
                            description: 'Accesorios de telefonia, accesorios para movil, accesorios para celulares',
                            id: 44,
                            showInStoreFront: true,
                            showBrandFilter: false,
                            activeStoreFrontLink: true,
                            name: 'Accesorios',
                            children: [
                                {
                                    isActive: false,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Estuches',
                                    fatherCategoryId: 44,
                                    description: 'Estuche, estuches, extuxes, protector de celulares, estuxes',
                                    id: 247,
                                    showInStoreFront: false,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: false,
                                    name: 'Estuches',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Accesorios',
                                    fatherCategoryId: 44,
                                    description: 'Accesorios',
                                    id: 283,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Accesorios',
                                    children: [],
                                    masterCategoryId: 0
                                }
                            ],
                            masterCategoryId: 0
                        },
                        {
                            isActive: false,
                            score: 0,
                            stockKeepingUnitSelectionMode: 'SPECIFICATION',
                            hasChildren: true,
                            title: 'Teléfonos Residenciales',
                            fatherCategoryId: 7,
                            description: 'Telefonos de casa, telefonia para el hogar, telefonos fijos',
                            id: 45,
                            showInStoreFront: false,
                            showBrandFilter: false,
                            activeStoreFrontLink: false,
                            name: 'Teléfonos Residenciales',
                            children: [
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Teléfonos Residenciales',
                                    fatherCategoryId: 45,
                                    description: 'Teléfonos Residenciales',
                                    id: 284,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Teléfonos Residenciales',
                                    children: [],
                                    masterCategoryId: 0
                                }
                            ],
                            masterCategoryId: 0
                        },
                        {
                            isActive: true,
                            score: 0,
                            stockKeepingUnitSelectionMode: 'SPECIFICATION',
                            hasChildren: true,
                            title: 'Prendas Inteligentes',
                            fatherCategoryId: 7,
                            description: 'Smartwatche, reloj, relojes, Smartwatches, Fitband, fit band, band, fit',
                            id: 46,
                            showInStoreFront: true,
                            showBrandFilter: false,
                            activeStoreFrontLink: true,
                            name: 'Prendas Inteligentes',
                            children: [
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Smartwatches',
                                    fatherCategoryId: 46,
                                    description: 'Smartwatches',
                                    id: 251,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Smartwatches',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Fit Band',
                                    fatherCategoryId: 46,
                                    description: 'Fit Band, band, fit, reloj, fitband',
                                    id: 252,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Fit Band',
                                    children: [],
                                    masterCategoryId: 0
                                }
                            ],
                            masterCategoryId: 0
                        },
                        {
                            isActive: true,
                            score: 0,
                            stockKeepingUnitSelectionMode: 'SPECIFICATION',
                            hasChildren: true,
                            title: 'Teléfonos',
                            fatherCategoryId: 7,
                            description: 'celulares, movistar, claro, telefonia abierta, tigo',
                            id: 47,
                            showInStoreFront: true,
                            showBrandFilter: false,
                            activeStoreFrontLink: true,
                            name: 'Teléfonos',
                            children: [
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Claro',
                                    fatherCategoryId: 47,
                                    description: 'celulares, claro, moviles',
                                    id: 253,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Claro',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: false,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Movistar',
                                    fatherCategoryId: 47,
                                    description: 'telefonos celulares, moviles, movistar',
                                    id: 254,
                                    showInStoreFront: false,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: false,
                                    name: 'Movistar',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Telefonia Liberada',
                                    fatherCategoryId: 47,
                                    description: 'Telefonia Abierta, celulares, móviles, Telefonia Liberada',
                                    id: 255,
                                    showInStoreFront: true,
                                    showBrandFilter: true,
                                    activeStoreFrontLink: true,
                                    name: 'Telefonia Liberada',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Tigo',
                                    fatherCategoryId: 47,
                                    description: 'Tigo, celulares, telefono celular, moviles',
                                    id: 256,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Tigo',
                                    children: [],
                                    masterCategoryId: 0
                                }
                            ],
                            masterCategoryId: 0
                        },
                        {
                            isActive: false,
                            score: 0,
                            stockKeepingUnitSelectionMode: 'SPECIFICATION',
                            hasChildren: true,
                            title: 'Bocinas',
                            fatherCategoryId: 7,
                            description: 'bocinas, portatiles, bocinitas, bocinas bluetooth, inalambricas, alambricas',
                            id: 48,
                            showInStoreFront: false,
                            showBrandFilter: false,
                            activeStoreFrontLink: false,
                            name: 'Bocinas',
                            children: [
                                {
                                    isActive: false,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Bocinas Portátiles',
                                    fatherCategoryId: 48,
                                    description: 'Bocinas portátiles, bocinas pequeñas, bocinas bluetooth, portatiles',
                                    id: 250,
                                    showInStoreFront: false,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: false,
                                    name: 'Bocinas Portátiles',
                                    children: [],
                                    masterCategoryId: 0
                                }
                            ],
                            masterCategoryId: 0
                        }
                    ],
                    masterCategoryId: 0
                },
                {
                    isActive: true,
                    score: 0,
                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                    hasChildren: true,
                    title: 'Elektra | Transporte',
                    fatherCategoryId: 0,
                    description: 'Llega más fácil a tu trabajo, casa o escuela con las mejores bicicletas. ¡Cómpralas en Elektra onlin',
                    id: 8,
                    showInStoreFront: true,
                    showBrandFilter: false,
                    activeStoreFrontLink: true,
                    name: 'Transporte',
                    numberChildren: 3,
                    children: [
                        {
                            isActive: true,
                            score: 0,
                            stockKeepingUnitSelectionMode: 'SPECIFICATION',
                            hasChildren: true,
                            title: 'Bicicletas',
                            fatherCategoryId: 8,
                            description: 'Bicis, vici, bicicletas, deporte al aire libre',
                            id: 49,
                            showInStoreFront: true,
                            showBrandFilter: false,
                            activeStoreFrontLink: true,
                            name: 'Bicicletas',
                            children: [
                                {
                                    isActive: false,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Adultos',
                                    fatherCategoryId: 49,
                                    description: 'Bici para adultos',
                                    id: 257,
                                    showInStoreFront: false,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: false,
                                    name: 'Adultos',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Infantil',
                                    fatherCategoryId: 49,
                                    description: 'Bici para niños, bici infantil',
                                    id: 258,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Infantil',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Urbana',
                                    fatherCategoryId: 49,
                                    description: 'Bicicletas urbanas, bicis urbanas, vicis urbanas',
                                    id: 259,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Urbana',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Eléctrica',
                                    fatherCategoryId: 49,
                                    description: 'Bicis eléctricas, vicis eléctricas, vicis electricas, electricas',
                                    id: 260,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Eléctrica',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Montaña',
                                    fatherCategoryId: 49,
                                    description: 'Montaña',
                                    id: 261,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Montaña',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Racing',
                                    fatherCategoryId: 49,
                                    description: 'Racing',
                                    id: 262,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Racing',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Accesorios',
                                    fatherCategoryId: 49,
                                    description: 'Accesorios',
                                    id: 285,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Accesorios',
                                    children: [],
                                    masterCategoryId: 0
                                }
                            ],
                            masterCategoryId: 0
                        },
                        {
                            isActive: true,
                            score: 0,
                            stockKeepingUnitSelectionMode: 'SPECIFICATION',
                            hasChildren: true,
                            title: 'Juguetes',
                            fatherCategoryId: 8,
                            description: 'Montables, infantiles, vehiculos infantiles',
                            id: 50,
                            showInStoreFront: true,
                            showBrandFilter: false,
                            activeStoreFrontLink: true,
                            name: 'Juguetes',
                            children: [
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Montables',
                                    fatherCategoryId: 50,
                                    description: 'Montables',
                                    id: 263,
                                    showInStoreFront: true,
                                    showBrandFilter: true,
                                    activeStoreFrontLink: true,
                                    name: 'Montables',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Triciclos',
                                    fatherCategoryId: 50,
                                    description: 'Triciclos y Scooters, vehiculos infantiles',
                                    id: 264,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Triciclos',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Patines',
                                    fatherCategoryId: 50,
                                    description: 'Patines, patin, patín, patinez',
                                    id: 265,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Patines',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Accesorios de Juguetes',
                                    fatherCategoryId: 50,
                                    description:
                                        'juguetes, rodilleras, cascos, rodillera, casco, codera, coderas, coderaz, protectores, rodilla, cabe',
                                    id: 266,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Accesorios de Juguetes',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Carruajes | Elektra GT',
                                    fatherCategoryId: 50,
                                    description: 'Carruajes',
                                    id: 267,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Carruajes',
                                    children: [],
                                    masterCategoryId: 0
                                }
                            ],
                            masterCategoryId: 0
                        },
                        {
                            isActive: true,
                            score: 0,
                            stockKeepingUnitSelectionMode: 'SPECIFICATION',
                            hasChildren: true,
                            title: 'Scooter',
                            fatherCategoryId: 8,
                            description: 'Scooter, Monopatin, monopatines, scooters',
                            id: 51,
                            showInStoreFront: true,
                            showBrandFilter: false,
                            activeStoreFrontLink: true,
                            name: 'Scooter',
                            children: [
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Scooter',
                                    fatherCategoryId: 51,
                                    description: 'Scooter',
                                    id: 286,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Scooter',
                                    children: [],
                                    masterCategoryId: 0
                                }
                            ],
                            masterCategoryId: 0
                        }
                    ],
                    masterCategoryId: 0
                },
                {
                    isActive: true,
                    score: 0,
                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                    hasChildren: true,
                    title: 'Ejercicios e Higiene',
                    fatherCategoryId: 0,
                    description: 'Salud, higiene, hijiene, zalud, cuidado personal',
                    id: 9,
                    showInStoreFront: true,
                    showBrandFilter: false,
                    activeStoreFrontLink: true,
                    name: 'Ejercicios e Higiene',
                    numberChildren: 2,
                    children: [
                        {
                            isActive: true,
                            score: 0,
                            stockKeepingUnitSelectionMode: 'SPECIFICATION',
                            hasChildren: true,
                            title: 'Cuidados de la Salud',
                            fatherCategoryId: 9,
                            description: 'Cuidados de la Salud',
                            id: 52,
                            showInStoreFront: true,
                            showBrandFilter: false,
                            activeStoreFrontLink: true,
                            name: 'Cuidados de la Salud',
                            children: [
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Elektra | Productos Médicos',
                                    fatherCategoryId: 52,
                                    description:
                                        'Sanitizadores, Concentradores, sanitisador, sanitizador, sanitisadores, concentrador, termometro, me',
                                    id: 112,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Productos Médicos',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Gel Antibacterial',
                                    fatherCategoryId: 52,
                                    description: 'Gel Antibacterial, 120ml, 500ml, 1 Galón',
                                    id: 113,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Gel Antibacterial',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Alcohol en Spray',
                                    fatherCategoryId: 52,
                                    description: 'Alcohol en Spray, alcohol, aerosol',
                                    id: 114,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Alcohol en Spray',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Escudo Facial',
                                    fatherCategoryId: 52,
                                    description: 'Escudo Facial, careta, protector  facial',
                                    id: 115,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Escudo Facial',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: false,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Guantes',
                                    fatherCategoryId: 52,
                                    description: 'guantes, juantes, guante, huantes, huante',
                                    id: 116,
                                    showInStoreFront: false,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: false,
                                    name: 'Guantes',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Mascarillas',
                                    fatherCategoryId: 52,
                                    description: 'Mascarilla, maskarilla, mazkarilla',
                                    id: 117,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Mascarillas',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Asistencia Elektra',
                                    fatherCategoryId: 52,
                                    description: 'Asistencia Elektra, medicos, medicina, asistencia medica, medica, medico',
                                    id: 118,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Asistencia Elektra',
                                    children: [],
                                    masterCategoryId: 0
                                }
                            ],
                            masterCategoryId: 0
                        },
                        {
                            isActive: true,
                            score: 0,
                            stockKeepingUnitSelectionMode: 'SPECIFICATION',
                            hasChildren: true,
                            title: 'Equipos de Ejercicio',
                            fatherCategoryId: 9,
                            description: 'Deportes, Ejercicios, ejercicio, deporte, Equipos de Ejercicios',
                            id: 53,
                            showInStoreFront: true,
                            showBrandFilter: false,
                            activeStoreFrontLink: true,
                            name: 'Equipos de Ejercicio',
                            children: [
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Maquinas de Ejercicio',
                                    fatherCategoryId: 53,
                                    description: 'Equipos de Ejercicios, ejercicios, deporte, deportivos, Maquinas de Ejercicio',
                                    id: 119,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Maquinas de Ejercicio',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Accesorios de Ejercicio',
                                    fatherCategoryId: 53,
                                    description: 'Accesorios de Ejercicio',
                                    id: 120,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Accesorios de Ejercicio',
                                    children: [],
                                    masterCategoryId: 0
                                }
                            ],
                            masterCategoryId: 0
                        }
                    ],
                    masterCategoryId: 0
                },
                {
                    isActive: false,
                    score: 0,
                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                    hasChildren: true,
                    title: 'Abarrotes',
                    fatherCategoryId: 0,
                    description: 'Abarroteria, abarrotes,  avarroteria, avarrotes, consumo diario, despensa',
                    id: 10,
                    showInStoreFront: false,
                    showBrandFilter: false,
                    activeStoreFrontLink: false,
                    name: 'Abarrotes',
                    numberChildren: 2,
                    children: [
                        {
                            isActive: false,
                            score: 0,
                            stockKeepingUnitSelectionMode: 'SPECIFICATION',
                            hasChildren: true,
                            title: 'Despensa',
                            fatherCategoryId: 10,
                            description: 'Comestibles, despensa, pasta, primera necesidad, comida, bebidas, canasta',
                            id: 54,
                            showInStoreFront: true,
                            showBrandFilter: false,
                            activeStoreFrontLink: true,
                            name: 'Despensa',
                            children: [
                                {
                                    isActive: false,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Jugos y Bebidas',
                                    fatherCategoryId: 54,
                                    description: 'Jugos, bebidas, jugo, bebidas, gaseosas, agua, agua pura, aguas, gaseosa, juguitos',
                                    id: 60,
                                    showInStoreFront: false,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: false,
                                    name: 'Jugos y Bebidas',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: false,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Pastas',
                                    fatherCategoryId: 54,
                                    description: 'pasta, pastas, fideos, caracolitos, fideo, espagetti, espagueti, espageti',
                                    id: 61,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Pastas',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: false,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Azucar y Sal',
                                    fatherCategoryId: 54,
                                    description: 'Azucar , sal, Azúcar',
                                    id: 62,
                                    showInStoreFront: false,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: false,
                                    name: 'Azúcar y Sal',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: false,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Café',
                                    fatherCategoryId: 54,
                                    description: 'Café, cafe',
                                    id: 63,
                                    showInStoreFront: false,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: false,
                                    name: 'Café',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: false,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Alimentos Instantáneos',
                                    fatherCategoryId: 54,
                                    description:
                                        'instantáneo, instantaneo, instantáneos, instantaneos, instantáneas, instantaneas, instantánea, insta',
                                    id: 64,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Alimentos Instantáneos',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: false,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Aceites y Margarinas',
                                    fatherCategoryId: 54,
                                    description: 'Aceite, Margarina, aseite, aseytes, aseites, aceyte,margaryna, marjarina',
                                    id: 65,
                                    showInStoreFront: false,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: false,
                                    name: 'Aceites y Margarinas',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: false,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Comestibles',
                                    fatherCategoryId: 54,
                                    description: 'Comestibles, canasta basica, comidas',
                                    id: 66,
                                    showInStoreFront: false,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: false,
                                    name: 'Comestibles',
                                    children: [],
                                    masterCategoryId: 0
                                }
                            ],
                            masterCategoryId: 0
                        },
                        {
                            isActive: false,
                            score: 0,
                            stockKeepingUnitSelectionMode: 'SPECIFICATION',
                            hasChildren: true,
                            title: 'Higiene y Limpieza',
                            fatherCategoryId: 10,
                            description: 'Cuidado corporal, detergentes, detergente, papel higiénico, papel, cloro, Limpieza',
                            id: 55,
                            showInStoreFront: true,
                            showBrandFilter: false,
                            activeStoreFrontLink: true,
                            name: 'Higiene y Limpieza',
                            children: [
                                {
                                    isActive: false,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Papel Higiénico',
                                    fatherCategoryId: 55,
                                    description: 'Papel, higiénico, higenico, higienico, hijienico',
                                    id: 67,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Papel Higiénico',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: false,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Limpieza del Hogar',
                                    fatherCategoryId: 55,
                                    description: 'limpieza, hogar, ogar, limpiesa',
                                    id: 68,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Limpieza del Hogar',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: true,
                                    title: 'Cuidado Personal',
                                    fatherCategoryId: 55,
                                    description: 'Cuidado Personal, corporal, manos, cuerpo, cabello',
                                    id: 104,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Cuidado Personal',
                                    children: [
                                        {
                                            isActive: false,
                                            score: 0,
                                            stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                            hasChildren: false,
                                            title: '',
                                            fatherCategoryId: 104,
                                            description: '',
                                            id: 268,
                                            showInStoreFront: false,
                                            showBrandFilter: false,
                                            activeStoreFrontLink: false,
                                            name: 'CombosInactivo',
                                            children: [],
                                            masterCategoryId: 0
                                        }
                                    ],
                                    masterCategoryId: 0
                                }
                            ],
                            masterCategoryId: 0
                        }
                    ],
                    masterCategoryId: 0
                },
                {
                    isActive: true,
                    score: 0,
                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                    hasChildren: true,
                    title: 'Ferretería',
                    fatherCategoryId: 0,
                    description: 'Herramientas, fereteria, ferreterias, ferretería',
                    id: 11,
                    showInStoreFront: true,
                    showBrandFilter: false,
                    activeStoreFrontLink: true,
                    name: 'Ferretería',
                    numberChildren: 2,
                    children: [
                        {
                            isActive: true,
                            score: 0,
                            stockKeepingUnitSelectionMode: 'SPECIFICATION',
                            hasChildren: true,
                            title: 'Herramienta Manual',
                            fatherCategoryId: 11,
                            description: 'Herramienta Manual',
                            id: 56,
                            showInStoreFront: true,
                            showBrandFilter: false,
                            activeStoreFrontLink: true,
                            name: 'Herramienta Manual',
                            children: [
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Escaleras',
                                    fatherCategoryId: 56,
                                    description: 'Escaleras',
                                    id: 169,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Escaleras',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Accesorios Eléctricos',
                                    fatherCategoryId: 56,
                                    description: 'Accesorios Eléctricos',
                                    id: 170,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Accesorios Eléctricos',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Kit de Herramientas',
                                    fatherCategoryId: 56,
                                    description: 'Kit de Herramientas',
                                    id: 171,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Kit de Herramientas',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Desbrozadoras y Podadoras',
                                    fatherCategoryId: 56,
                                    description: 'Desbrozadoras y Podadoras',
                                    id: 172,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Desbrozadoras y Podadoras',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Bombas de Aire',
                                    fatherCategoryId: 56,
                                    description: 'Bombas de Aire, Infladores, Inflador',
                                    id: 173,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Bombas de Aire',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: false,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: true,
                                    title: 'Herramientas Manuales',
                                    fatherCategoryId: 56,
                                    description: 'Herramientas Manuales',
                                    id: 174,
                                    showInStoreFront: false,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: false,
                                    name: 'Herramientas Manuales',
                                    children: [
                                        {
                                            isActive: true,
                                            score: 0,
                                            stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                            hasChildren: false,
                                            title: '',
                                            fatherCategoryId: 174,
                                            description: '',
                                            id: 277,
                                            showInStoreFront: false,
                                            showBrandFilter: false,
                                            activeStoreFrontLink: false,
                                            name: 'Accesorios de Ferretería',
                                            children: [],
                                            masterCategoryId: 0
                                        }
                                    ],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Herramientas Mecánicas',
                                    fatherCategoryId: 56,
                                    description: 'Herramientas Mecánicas',
                                    id: 175,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Herramientas Mecánicas',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Accesorios de Ferretería',
                                    fatherCategoryId: 56,
                                    description: 'Accesorios de Ferretería',
                                    id: 176,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Accesorios de Ferretería',
                                    children: [],
                                    masterCategoryId: 0
                                }
                            ],
                            masterCategoryId: 0
                        },
                        {
                            isActive: true,
                            score: 0,
                            stockKeepingUnitSelectionMode: 'SPECIFICATION',
                            hasChildren: true,
                            title: 'Herramienta Eléctrica',
                            fatherCategoryId: 11,
                            description: 'Herramienta Eléctrica',
                            id: 57,
                            showInStoreFront: true,
                            showBrandFilter: false,
                            activeStoreFrontLink: true,
                            name: 'Herramienta Eléctrica',
                            children: [
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Generadores',
                                    fatherCategoryId: 57,
                                    description: 'Productos de Fuerza, Generadores',
                                    id: 159,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Generadores',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Rotomartillos y Taladros',
                                    fatherCategoryId: 57,
                                    description: 'Rotomartillos y Taladros',
                                    id: 160,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Rotomartillos y Taladros',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Esmeriladoras Angulares',
                                    fatherCategoryId: 57,
                                    description: 'Esmeriladoras Angulares',
                                    id: 161,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Esmeriladoras Angulares',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Sierras y Caladoras',
                                    fatherCategoryId: 57,
                                    description: 'Sierras y Caladoras',
                                    id: 162,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Sierras y Caladoras',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Pulidoras',
                                    fatherCategoryId: 57,
                                    description: 'Pulidoras',
                                    id: 163,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Pulidoras',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Pistolas Eléctricas para Pintura',
                                    fatherCategoryId: 57,
                                    description: 'Pistolas Eléctricas para Pintura',
                                    id: 164,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Pistolas Eléctricas para Pintura',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Herramienta Inalámbrica',
                                    fatherCategoryId: 57,
                                    description: 'Herramienta Inalámbrica',
                                    id: 165,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Herramienta Inalámbrica',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Bombas de Agua',
                                    fatherCategoryId: 57,
                                    description: 'Bombas de Agua, bombas, sisterna, cisterna, cisternas, sisternas',
                                    id: 166,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Bombas de Agua',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Soldadoras',
                                    fatherCategoryId: 57,
                                    description: 'soldador, zoldador, zoldadorez, soldadores, zoldadoras, soldadoraz',
                                    id: 167,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Soldadoras',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Demoledores',
                                    fatherCategoryId: 57,
                                    description: 'Demoledores, demoledora, demoledorez, demolelor',
                                    id: 168,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Demoledores',
                                    children: [],
                                    masterCategoryId: 0
                                }
                            ],
                            masterCategoryId: 0
                        }
                    ],
                    masterCategoryId: 0
                },
                {
                    isActive: true,
                    score: 0,
                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                    hasChildren: true,
                    title: 'Electrodomésticos',
                    fatherCategoryId: 0,
                    description: 'Electrodomésticos, electrodomestico, electrodomesticos, electrodomésticos',
                    id: 12,
                    showInStoreFront: true,
                    showBrandFilter: false,
                    activeStoreFrontLink: true,
                    name: 'Electrodomésticos',
                    numberChildren: 3,
                    children: [
                        {
                            isActive: true,
                            score: 0,
                            stockKeepingUnitSelectionMode: 'SPECIFICATION',
                            hasChildren: true,
                            title: 'Cuidado Personal',
                            fatherCategoryId: 12,
                            description: 'rasuradora, secadoras de pelo, belleza',
                            id: 58,
                            showInStoreFront: true,
                            showBrandFilter: false,
                            activeStoreFrontLink: true,
                            name: 'Cuidado Personal',
                            children: [
                                {
                                    isActive: false,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Combos',
                                    fatherCategoryId: 58,
                                    description: 'Combos',
                                    id: 85,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Combos',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Caballero',
                                    fatherCategoryId: 58,
                                    description:
                                        'Cuidado personal caballero, accesorios para caballero, caballeros, rasuradoras, razudadora',
                                    id: 121,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Caballero',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Dama',
                                    fatherCategoryId: 58,
                                    description: 'Cuidado personal dama, plancha de pelo, rizador, alisador',
                                    id: 122,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Dama',
                                    children: [],
                                    masterCategoryId: 0
                                }
                            ],
                            masterCategoryId: 0
                        },
                        {
                            isActive: true,
                            score: 0,
                            stockKeepingUnitSelectionMode: 'SPECIFICATION',
                            hasChildren: true,
                            title: 'Dispensadores de Agua',
                            fatherCategoryId: 12,
                            description: 'Dispensadores de Agua',
                            id: 59,
                            showInStoreFront: true,
                            showBrandFilter: false,
                            activeStoreFrontLink: true,
                            name: 'Dispensadores de Agua',
                            children: [
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Ecofiltro',
                                    fatherCategoryId: 59,
                                    description: 'Ecofiltro',
                                    id: 123,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Ecofiltro',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Dispensadores de Agua',
                                    fatherCategoryId: 59,
                                    description: 'Dispensadores de Agua',
                                    id: 269,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Dispensadores de Agua',
                                    children: [],
                                    masterCategoryId: 0
                                }
                            ],
                            masterCategoryId: 0
                        },
                        {
                            isActive: true,
                            score: 0,
                            stockKeepingUnitSelectionMode: 'SPECIFICATION',
                            hasChildren: true,
                            title: 'Electrodomésticos',
                            fatherCategoryId: 12,
                            description: 'Electrodomésticos',
                            id: 109,
                            showInStoreFront: true,
                            showBrandFilter: false,
                            activeStoreFrontLink: true,
                            name: 'Electrodomésticos',
                            children: [
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Cafeteras',
                                    fatherCategoryId: 109,
                                    description: 'Cafeteras, electrodomésticos',
                                    id: 124,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Cafeteras',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Procesadores Electrodomésticos',
                                    fatherCategoryId: 109,
                                    description: 'Procesadores Electrodomésticos',
                                    id: 125,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Procesadores',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Licuadoras',
                                    fatherCategoryId: 109,
                                    description: 'Licuadora, licuadoras',
                                    id: 126,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Licuadoras',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Maquinas de Coser',
                                    fatherCategoryId: 109,
                                    description: 'maquina de coser, coser',
                                    id: 127,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Maquinas de Coser',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Planchas',
                                    fatherCategoryId: 109,
                                    description: 'Planchas, plancha',
                                    id: 128,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Planchas',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Hornos De Microondas',
                                    fatherCategoryId: 109,
                                    description: 'Hornos De Microondas',
                                    id: 129,
                                    showInStoreFront: true,
                                    showBrandFilter: true,
                                    activeStoreFrontLink: true,
                                    name: 'Hornos De Microondas',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Hidrolavadoras',
                                    fatherCategoryId: 109,
                                    description: 'Hidrolavadoras',
                                    id: 130,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Hidrolavadoras',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Aspiradoras Y Vaporizadores',
                                    fatherCategoryId: 109,
                                    description: 'Aspiradoras Y Vaporizadores',
                                    id: 131,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Aspiradoras Y Vaporizadores',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Ollas Electrodomésticos',
                                    fatherCategoryId: 109,
                                    description: 'Ollas Electrodomésticos',
                                    id: 132,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Ollas',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Hornos Tostadores Electrodomésticos',
                                    fatherCategoryId: 109,
                                    description: 'Hornos Tostadores Electrodomésticos',
                                    id: 133,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Hornos Tostadores',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Batidoras Electrodomésticos',
                                    fatherCategoryId: 109,
                                    description: 'Batidoras Electrodomésticos',
                                    id: 134,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Batidoras',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Freidoras Electrodomésticos',
                                    fatherCategoryId: 109,
                                    description: 'Freidoras Electrodomésticos',
                                    id: 135,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Freidoras',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Anterior - Hornos De Microondas',
                                    fatherCategoryId: 109,
                                    description: 'Anterior - Hornos De Microondas',
                                    id: 270,
                                    showInStoreFront: false,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: false,
                                    name: 'Anterior - Hornos De Microondas',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Cocina',
                                    fatherCategoryId: 109,
                                    description: 'Cocina',
                                    id: 271,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Cocina',
                                    children: [],
                                    masterCategoryId: 0
                                },
                                {
                                    isActive: true,
                                    score: 0,
                                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                                    hasChildren: false,
                                    title: 'Combos',
                                    fatherCategoryId: 109,
                                    description: 'Combos',
                                    id: 272,
                                    showInStoreFront: true,
                                    showBrandFilter: false,
                                    activeStoreFrontLink: true,
                                    name: 'Combos',
                                    children: [],
                                    masterCategoryId: 0
                                }
                            ],
                            masterCategoryId: 0
                        }
                    ],
                    masterCategoryId: 0
                },
                {
                    isActive: true,
                    score: 0,
                    stockKeepingUnitSelectionMode: 'LIST',
                    hasChildren: true,
                    title: 'Farmacia',
                    fatherCategoryId: 0,
                    description: '',
                    id: 287,
                    showInStoreFront: true,
                    showBrandFilter: true,
                    activeStoreFrontLink: true,
                    name: 'Farmacia',
                    numberChildren: 1,
                    children: [
                        {
                            isActive: true,
                            score: 0,
                            stockKeepingUnitSelectionMode: 'LIST',
                            hasChildren: false,
                            title: 'Drogas',
                            fatherCategoryId: 287,
                            description: 'drogas, tachas',
                            id: 288,
                            showInStoreFront: true,
                            showBrandFilter: true,
                            activeStoreFrontLink: true,
                            name: 'Drogas',
                            children: [],
                            masterCategoryId: 0
                        }
                    ],
                    masterCategoryId: 0
                },
                {
                    isActive: true,
                    score: 0,
                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                    hasChildren: false,
                    title: '',
                    fatherCategoryId: 0,
                    description: '',
                    id: 289,
                    showInStoreFront: false,
                    showBrandFilter: false,
                    activeStoreFrontLink: false,
                    name: 'test vinneren',
                    numberChildren: 0,
                    masterCategoryId: 0
                },
                {
                    isActive: true,
                    score: 0,
                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                    hasChildren: false,
                    title: 'Home Appliances',
                    fatherCategoryId: 0,
                    description: 'Discover our range of home appliances. Find smart vacuums, kitchen and laundry appliances to suit yo',
                    id: 9289,
                    showInStoreFront: true,
                    showBrandFilter: true,
                    activeStoreFrontLink: true,
                    name: 'Home Appliances',
                    numberChildren: 0,
                    masterCategoryId: 0
                },
                {
                    isActive: true,
                    score: 0,
                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                    hasChildren: false,
                    title: 'Home Appliances',
                    fatherCategoryId: 0,
                    description: 'Discover our range of home appliances. Find smart vacuums, kitchen and laundry appliances to suit yo',
                    id: 9290,
                    showInStoreFront: true,
                    showBrandFilter: true,
                    activeStoreFrontLink: true,
                    name: 'Home Appliances 2',
                    numberChildren: 0,
                    masterCategoryId: 0
                },
                {
                    isActive: true,
                    score: 0,
                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                    hasChildren: false,
                    title: 'Home Appliances',
                    fatherCategoryId: 0,
                    description: 'Discover our range of home appliances. Find smart vacuums, kitchen and laundry appliances to suit yo',
                    id: 9291,
                    showInStoreFront: true,
                    showBrandFilter: true,
                    activeStoreFrontLink: true,
                    name: 'Home Appliances 3',
                    numberChildren: 0,
                    masterCategoryId: 0
                },
                {
                    isActive: true,
                    score: 0,
                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                    hasChildren: false,
                    title: '',
                    fatherCategoryId: 0,
                    description: 'Apps published on VTEX App Store',
                    id: 9292,
                    showInStoreFront: true,
                    showBrandFilter: true,
                    activeStoreFrontLink: true,
                    name: 'Apps01',
                    numberChildren: 0,
                    masterCategoryId: 0
                },
                {
                    isActive: true,
                    score: 0,
                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                    hasChildren: false,
                    title: '',
                    fatherCategoryId: 0,
                    description: 'Apps published on VTEX App Store',
                    id: 9293,
                    showInStoreFront: true,
                    showBrandFilter: true,
                    activeStoreFrontLink: true,
                    name: 'Apps',
                    numberChildren: 0,
                    masterCategoryId: 0
                },
                {
                    isActive: true,
                    score: 0,
                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                    hasChildren: false,
                    title: '',
                    fatherCategoryId: 0,
                    description: 'Apps published on VTEX App Store',
                    id: 9294,
                    showInStoreFront: true,
                    showBrandFilter: true,
                    activeStoreFrontLink: true,
                    name: 'Apps',
                    numberChildren: 0,
                    masterCategoryId: 0
                },
                {
                    isActive: true,
                    score: 0,
                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                    hasChildren: true,
                    title: 'Mesa europea',
                    fatherCategoryId: 0,
                    description: '',
                    id: 9295,
                    showInStoreFront: true,
                    showBrandFilter: true,
                    activeStoreFrontLink: true,
                    name: 'Mesa europea DEMO whirpool 15:10',
                    numberChildren: 1,
                    children: [
                        {
                            isActive: true,
                            score: 10,
                            stockKeepingUnitSelectionMode: 'SPECIFICATION',
                            hasChildren: false,
                            title: '',
                            fatherCategoryId: 9295,
                            description: '',
                            id: 9297,
                            showInStoreFront: true,
                            showBrandFilter: true,
                            activeStoreFrontLink: true,
                            name: 'Hijo 1 categoria',
                            children: [],
                            masterCategoryId: 0
                        }
                    ],
                    masterCategoryId: 0
                },
                {
                    isActive: true,
                    score: 0,
                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                    hasChildren: false,
                    fatherCategoryId: 0,
                    id: 9298,
                    showInStoreFront: false,
                    showBrandFilter: false,
                    activeStoreFrontLink: false,
                    name: 'test vinneren 02',
                    numberChildren: 0,
                    masterCategoryId: 0
                },
                {
                    isActive: true,
                    score: 0,
                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                    hasChildren: false,
                    fatherCategoryId: 0,
                    id: 9299,
                    showInStoreFront: false,
                    showBrandFilter: false,
                    activeStoreFrontLink: false,
                    name: 'test vinneren 03',
                    numberChildren: 0,
                    masterCategoryId: 0
                },
                {
                    isActive: true,
                    score: 0,
                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                    hasChildren: false,
                    fatherCategoryId: 0,
                    id: 9300,
                    showInStoreFront: false,
                    showBrandFilter: false,
                    activeStoreFrontLink: false,
                    name: 'test vinneren 04',
                    numberChildren: 0,
                    masterCategoryId: 0
                },
                {
                    isActive: true,
                    score: 0,
                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                    hasChildren: false,
                    title: 'Category multicatalog',
                    fatherCategoryId: 0,
                    description: 'Category multicatalog',
                    id: 11501908,
                    showInStoreFront: false,
                    showBrandFilter: true,
                    activeStoreFrontLink: true,
                    name: 'Category multicatalog',
                    numberChildren: 0,
                    masterCategoryId: 0
                },
                {
                    isActive: true,
                    score: 0,
                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                    hasChildren: false,
                    title: 'test vinneren 05',
                    fatherCategoryId: 0,
                    id: 11501909,
                    showInStoreFront: false,
                    showBrandFilter: false,
                    activeStoreFrontLink: false,
                    name: 'test vinneren 05',
                    numberChildren: 0,
                    masterCategoryId: 0
                },
                {
                    isActive: true,
                    score: 0,
                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                    hasChildren: false,
                    title: 'Caseteras',
                    fatherCategoryId: 0,
                    id: 11501910,
                    showInStoreFront: false,
                    showBrandFilter: false,
                    activeStoreFrontLink: false,
                    name: 'Caseteras',
                    numberChildren: 0,
                    masterCategoryId: 0
                },
                {
                    isActive: true,
                    score: 0,
                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                    hasChildren: false,
                    title: 'Aspiradoras',
                    fatherCategoryId: 0,
                    id: 11501911,
                    showInStoreFront: false,
                    showBrandFilter: false,
                    activeStoreFrontLink: false,
                    name: 'Aspiradoras',
                    numberChildren: 0,
                    masterCategoryId: 0
                },
                {
                    isActive: true,
                    score: 0,
                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                    hasChildren: false,
                    title: 'Category multicatalog 12809_1',
                    fatherCategoryId: 0,
                    description: 'Category multicatalog 12809_1',
                    id: 11501912,
                    showInStoreFront: false,
                    showBrandFilter: true,
                    activeStoreFrontLink: true,
                    name: 'Category multicatalog 12809_1',
                    numberChildren: 0,
                    masterCategoryId: 0
                },
                {
                    isActive: true,
                    score: 0,
                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                    hasChildren: false,
                    title: 'Category multicatalog 12809_2',
                    fatherCategoryId: 0,
                    description: 'Category multicatalog 12809_2',
                    id: 11501913,
                    showInStoreFront: false,
                    showBrandFilter: true,
                    activeStoreFrontLink: true,
                    name: 'Category multicatalog 12809_2',
                    numberChildren: 0,
                    masterCategoryId: 0
                },
                {
                    isActive: true,
                    score: 0,
                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                    hasChildren: false,
                    title: 'Category multicatalog 12809_3',
                    fatherCategoryId: 0,
                    description: 'Category multicatalog 12809_3',
                    id: 11501914,
                    showInStoreFront: false,
                    showBrandFilter: true,
                    activeStoreFrontLink: true,
                    name: 'Category multicatalog 12809_3',
                    numberChildren: 0,
                    masterCategoryId: 0
                },
                {
                    isActive: true,
                    score: 0,
                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                    hasChildren: false,
                    title: 'Category multicatalog 12809_4',
                    fatherCategoryId: 0,
                    description: 'Category multicatalog 12809_4',
                    id: 11501916,
                    showInStoreFront: false,
                    showBrandFilter: true,
                    activeStoreFrontLink: true,
                    name: 'Category multicatalog 12809_4',
                    numberChildren: 0,
                    masterCategoryId: 0
                },
                {
                    isActive: true,
                    score: 0,
                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                    hasChildren: false,
                    title: 'Computadoras Gamer',
                    fatherCategoryId: 0,
                    id: 11501917,
                    showInStoreFront: false,
                    showBrandFilter: false,
                    activeStoreFrontLink: false,
                    name: 'Computadoras Gamer',
                    numberChildren: 0,
                    masterCategoryId: 0
                },
                {
                    isActive: true,
                    score: 0,
                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                    hasChildren: false,
                    title: 'Focos',
                    fatherCategoryId: 0,
                    id: 11501918,
                    showInStoreFront: false,
                    showBrandFilter: false,
                    activeStoreFrontLink: false,
                    name: 'Focos',
                    numberChildren: 0,
                    masterCategoryId: 0
                },
                {
                    isActive: true,
                    score: 0,
                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                    hasChildren: false,
                    title: 'MasterCategory',
                    fatherCategoryId: 0,
                    id: 11501919,
                    showInStoreFront: false,
                    showBrandFilter: false,
                    activeStoreFrontLink: false,
                    name: 'MasterCategory',
                    numberChildren: 0,
                    masterCategoryId: 0
                },
                {
                    isActive: true,
                    score: 0,
                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                    hasChildren: false,
                    title: 'MasterCategory01',
                    fatherCategoryId: 0,
                    id: 11501920,
                    showInStoreFront: false,
                    showBrandFilter: false,
                    activeStoreFrontLink: false,
                    name: 'MasterCategory01',
                    numberChildren: 0,
                    masterCategoryId: 0
                },
                {
                    isActive: true,
                    score: 0,
                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                    hasChildren: false,
                    title: 'MasterCategory02',
                    fatherCategoryId: 0,
                    id: 11501921,
                    showInStoreFront: false,
                    showBrandFilter: false,
                    activeStoreFrontLink: false,
                    name: 'MasterCategory02',
                    numberChildren: 0,
                    masterCategoryId: 0
                },
                {
                    isActive: true,
                    score: 0,
                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                    hasChildren: false,
                    title: 'MasterCategory03',
                    fatherCategoryId: 0,
                    id: 11501922,
                    showInStoreFront: false,
                    showBrandFilter: false,
                    activeStoreFrontLink: false,
                    name: 'MasterCategory03',
                    numberChildren: 0,
                    masterCategoryId: 0
                },
                {
                    isActive: true,
                    score: 0,
                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                    hasChildren: false,
                    title: 'MasterCategory04',
                    fatherCategoryId: 0,
                    id: 11501923,
                    showInStoreFront: false,
                    showBrandFilter: false,
                    activeStoreFrontLink: false,
                    name: 'MasterCategory04',
                    numberChildren: 0,
                    masterCategoryId: 0
                },
                {
                    isActive: true,
                    score: 0,
                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                    hasChildren: false,
                    title: 'MasterCategory05',
                    fatherCategoryId: 0,
                    id: 11501924,
                    showInStoreFront: false,
                    showBrandFilter: false,
                    activeStoreFrontLink: false,
                    name: 'MasterCategory05',
                    numberChildren: 0,
                    masterCategoryId: 0
                },
                {
                    isActive: true,
                    score: 0,
                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                    hasChildren: false,
                    title: 'MasterCategory06',
                    fatherCategoryId: 0,
                    id: 11501925,
                    showInStoreFront: false,
                    showBrandFilter: false,
                    activeStoreFrontLink: false,
                    name: 'MasterCategory06',
                    numberChildren: 0,
                    masterCategoryId: 0
                },
                {
                    isActive: true,
                    score: 0,
                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                    hasChildren: false,
                    title: 'MasterCategory07',
                    fatherCategoryId: 0,
                    id: 11501926,
                    showInStoreFront: false,
                    showBrandFilter: false,
                    activeStoreFrontLink: false,
                    name: 'MasterCategory07',
                    numberChildren: 0,
                    masterCategoryId: 0
                },
                {
                    isActive: true,
                    score: 0,
                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                    hasChildren: false,
                    title: 'MasterCategory08',
                    fatherCategoryId: 0,
                    id: 11501927,
                    showInStoreFront: false,
                    showBrandFilter: false,
                    activeStoreFrontLink: false,
                    name: 'MasterCategory08',
                    numberChildren: 0,
                    masterCategoryId: 0
                },
                {
                    isActive: true,
                    score: 0,
                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                    hasChildren: false,
                    title: 'MasterCategory09',
                    fatherCategoryId: 0,
                    id: 11501928,
                    showInStoreFront: false,
                    showBrandFilter: false,
                    activeStoreFrontLink: false,
                    name: 'MasterCategory09',
                    numberChildren: 0,
                    masterCategoryId: 0
                },
                {
                    isActive: true,
                    score: 0,
                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                    hasChildren: false,
                    title: 'MasterCategory10',
                    fatherCategoryId: 0,
                    id: 11501929,
                    showInStoreFront: false,
                    showBrandFilter: false,
                    activeStoreFrontLink: false,
                    name: 'MasterCategory10',
                    numberChildren: 0,
                    masterCategoryId: 0
                },
                {
                    isActive: true,
                    score: 0,
                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                    hasChildren: false,
                    title: 'MasterCategory11',
                    fatherCategoryId: 0,
                    id: 11501930,
                    showInStoreFront: false,
                    showBrandFilter: false,
                    activeStoreFrontLink: false,
                    name: 'MasterCategory11',
                    numberChildren: 0,
                    masterCategoryId: 0
                },
                {
                    isActive: true,
                    score: 0,
                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                    hasChildren: false,
                    title: 'MasterCategory12',
                    fatherCategoryId: 0,
                    id: 11501931,
                    showInStoreFront: false,
                    showBrandFilter: false,
                    activeStoreFrontLink: false,
                    name: 'MasterCategory12',
                    numberChildren: 0,
                    masterCategoryId: 0
                },
                {
                    isActive: true,
                    score: 0,
                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                    hasChildren: false,
                    title: 'MasterCategory13',
                    fatherCategoryId: 0,
                    id: 11501932,
                    showInStoreFront: false,
                    showBrandFilter: false,
                    activeStoreFrontLink: false,
                    name: 'MasterCategory13',
                    numberChildren: 0,
                    masterCategoryId: 0
                },
                {
                    isActive: true,
                    score: 0,
                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                    hasChildren: false,
                    title: 'MasterCategory14',
                    fatherCategoryId: 0,
                    id: 11501933,
                    showInStoreFront: false,
                    showBrandFilter: false,
                    activeStoreFrontLink: false,
                    name: 'MasterCategory14',
                    numberChildren: 0,
                    masterCategoryId: 0
                },
                {
                    isActive: true,
                    score: 0,
                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                    hasChildren: false,
                    title: 'MasterCategory15',
                    fatherCategoryId: 0,
                    id: 11501934,
                    showInStoreFront: false,
                    showBrandFilter: false,
                    activeStoreFrontLink: false,
                    name: 'MasterCategory15',
                    numberChildren: 0,
                    masterCategoryId: 0
                },
                {
                    isActive: true,
                    score: 0,
                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                    hasChildren: false,
                    title: 'masterCategory16',
                    fatherCategoryId: 0,
                    id: 11501935,
                    showInStoreFront: false,
                    showBrandFilter: false,
                    activeStoreFrontLink: false,
                    name: 'masterCategory16',
                    numberChildren: 0,
                    masterCategoryId: 0
                },
                {
                    isActive: true,
                    score: 0,
                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                    hasChildren: false,
                    title: 'Mastercategory17',
                    fatherCategoryId: 0,
                    id: 11501936,
                    showInStoreFront: false,
                    showBrandFilter: false,
                    activeStoreFrontLink: false,
                    name: 'Mastercategory17',
                    numberChildren: 0,
                    masterCategoryId: 0
                },
                {
                    isActive: true,
                    score: 0,
                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                    hasChildren: false,
                    title: 'MasterCategory18',
                    fatherCategoryId: 0,
                    id: 11501937,
                    showInStoreFront: false,
                    showBrandFilter: false,
                    activeStoreFrontLink: false,
                    name: 'MasterCategory18',
                    numberChildren: 0,
                    masterCategoryId: 0
                },
                {
                    isActive: true,
                    score: 0,
                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                    hasChildren: false,
                    title: 'MasterCategory19',
                    fatherCategoryId: 0,
                    id: 11501938,
                    showInStoreFront: false,
                    showBrandFilter: false,
                    activeStoreFrontLink: false,
                    name: 'MasterCategory19',
                    numberChildren: 0,
                    masterCategoryId: 0
                },
                {
                    isActive: true,
                    score: 0,
                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                    hasChildren: false,
                    title: 'Mastercategory20',
                    fatherCategoryId: 0,
                    id: 11501939,
                    showInStoreFront: false,
                    showBrandFilter: false,
                    activeStoreFrontLink: false,
                    name: 'Mastercategory20',
                    numberChildren: 0,
                    masterCategoryId: 0
                },
                {
                    isActive: true,
                    score: 0,
                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                    hasChildren: false,
                    title: 'MasterCategory21',
                    fatherCategoryId: 0,
                    id: 11501940,
                    showInStoreFront: false,
                    showBrandFilter: false,
                    activeStoreFrontLink: false,
                    name: 'MasterCategory21',
                    numberChildren: 0,
                    masterCategoryId: 0
                },
                {
                    isActive: true,
                    score: 0,
                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                    hasChildren: false,
                    title: 'MasterCategory22',
                    fatherCategoryId: 0,
                    id: 11501941,
                    showInStoreFront: false,
                    showBrandFilter: false,
                    activeStoreFrontLink: false,
                    name: 'MasterCategory22',
                    numberChildren: 0,
                    masterCategoryId: 0
                },
                {
                    isActive: true,
                    score: 0,
                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                    hasChildren: false,
                    title: 'MasterCategory23',
                    fatherCategoryId: 0,
                    id: 11501942,
                    showInStoreFront: false,
                    showBrandFilter: false,
                    activeStoreFrontLink: false,
                    name: 'MasterCategory23',
                    numberChildren: 0,
                    masterCategoryId: 0
                },
                {
                    isActive: true,
                    score: 0,
                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                    hasChildren: false,
                    title: 'MasterCategory24',
                    fatherCategoryId: 0,
                    id: 11501943,
                    showInStoreFront: false,
                    showBrandFilter: false,
                    activeStoreFrontLink: false,
                    name: 'MasterCategory24',
                    numberChildren: 0,
                    masterCategoryId: 0
                },
                {
                    isActive: true,
                    score: 0,
                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                    hasChildren: false,
                    title: 'MasterCategory25',
                    fatherCategoryId: 0,
                    id: 11501944,
                    showInStoreFront: false,
                    showBrandFilter: false,
                    activeStoreFrontLink: false,
                    name: 'MasterCategory25',
                    numberChildren: 0,
                    masterCategoryId: 0
                },
                {
                    isActive: true,
                    score: 0,
                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                    hasChildren: false,
                    title: 'Mastercategory26',
                    fatherCategoryId: 0,
                    id: 11501945,
                    showInStoreFront: false,
                    showBrandFilter: false,
                    activeStoreFrontLink: false,
                    name: 'Mastercategory26',
                    numberChildren: 0,
                    masterCategoryId: 0
                },
                {
                    isActive: true,
                    score: 0,
                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                    hasChildren: false,
                    title: 'SuperCat01',
                    fatherCategoryId: 0,
                    id: 11501946,
                    showInStoreFront: false,
                    showBrandFilter: false,
                    activeStoreFrontLink: false,
                    name: 'SuperCat01',
                    numberChildren: 0,
                    masterCategoryId: 0
                },
                {
                    isActive: true,
                    score: 0,
                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                    hasChildren: false,
                    title: 'SuperCat02',
                    fatherCategoryId: 0,
                    id: 11501947,
                    showInStoreFront: false,
                    showBrandFilter: false,
                    activeStoreFrontLink: false,
                    name: 'SuperCat02',
                    numberChildren: 0,
                    masterCategoryId: 0
                },
                {
                    isActive: true,
                    score: 0,
                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                    hasChildren: false,
                    title: 'SuperCat03',
                    fatherCategoryId: 0,
                    id: 11501948,
                    showInStoreFront: false,
                    showBrandFilter: false,
                    activeStoreFrontLink: false,
                    name: 'SuperCat03',
                    numberChildren: 0,
                    masterCategoryId: 0
                },
                {
                    isActive: true,
                    score: 0,
                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                    hasChildren: false,
                    title: 'Autos',
                    fatherCategoryId: 0,
                    id: 11501950,
                    showInStoreFront: false,
                    showBrandFilter: false,
                    activeStoreFrontLink: false,
                    name: 'Autos',
                    numberChildren: 0,
                    masterCategoryId: 0
                },
                {
                    isActive: true,
                    score: 0,
                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                    hasChildren: false,
                    title: 'Autos',
                    fatherCategoryId: 0,
                    id: 11501951,
                    showInStoreFront: false,
                    showBrandFilter: false,
                    activeStoreFrontLink: false,
                    name: 'Autos',
                    numberChildren: 0,
                    masterCategoryId: 0
                },
                {
                    isActive: true,
                    score: 0,
                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                    hasChildren: false,
                    title: 'Categoria Padre Test',
                    fatherCategoryId: 0,
                    id: 11501952,
                    showInStoreFront: false,
                    showBrandFilter: false,
                    activeStoreFrontLink: false,
                    name: 'Categoria Padre Test',
                    numberChildren: 0,
                    masterCategoryId: 0
                },
                {
                    isActive: true,
                    score: 0,
                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                    hasChildren: false,
                    title: 'Categoria Padre test Vinne',
                    fatherCategoryId: 0,
                    id: 11501953,
                    showInStoreFront: false,
                    showBrandFilter: false,
                    activeStoreFrontLink: false,
                    name: 'Categoria Padre test Vinne',
                    numberChildren: 0,
                    masterCategoryId: 0
                }
            ]
        },
        {
            idMerchant: 2,
            isFatherMerchant: false,
            categoryList: [
                {
                    isActive: true,
                    score: 0,
                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                    hasChildren: false,
                    title: 'SuperCat',
                    fatherCategoryId: 0,
                    id: 23,
                    showInStoreFront: false,
                    showBrandFilter: false,
                    activeStoreFrontLink: false,
                    name: 'SuperCat',
                    numberChildren: 0,
                    masterCategoryId: 0
                },
                {
                    isActive: true,
                    score: 0,
                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                    hasChildren: false,
                    title: 'SuperCat2',
                    fatherCategoryId: 0,
                    id: 24,
                    showInStoreFront: false,
                    showBrandFilter: false,
                    activeStoreFrontLink: false,
                    name: 'SuperCat2',
                    numberChildren: 0,
                    masterCategoryId: 0
                },
                {
                    isActive: true,
                    score: 0,
                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                    hasChildren: false,
                    title: 'SuperCat3',
                    fatherCategoryId: 0,
                    id: 25,
                    showInStoreFront: false,
                    showBrandFilter: false,
                    activeStoreFrontLink: false,
                    name: 'SuperCat3',
                    numberChildren: 0,
                    masterCategoryId: 0
                },
                {
                    isActive: true,
                    score: 0,
                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                    hasChildren: false,
                    title: 'SuperCat4',
                    fatherCategoryId: 0,
                    id: 26,
                    showInStoreFront: false,
                    showBrandFilter: false,
                    activeStoreFrontLink: false,
                    name: 'SuperCat4',
                    numberChildren: 2,
                    children: [
                        {
                            isActive: true,
                            score: 0,
                            stockKeepingUnitSelectionMode: 'SPECIFICATION',
                            hasChildren: false,
                            title: 'Autos',
                            fatherCategoryId: 26,
                            id: 61,
                            showInStoreFront: false,
                            showBrandFilter: false,
                            activeStoreFrontLink: false,
                            name: 'Autos',
                            children: [],
                            masterCategoryId: 0
                        },
                        {
                            isActive: true,
                            score: 0,
                            stockKeepingUnitSelectionMode: 'SPECIFICATION',
                            hasChildren: false,
                            title: 'Autos',
                            fatherCategoryId: 26,
                            id: 62,
                            showInStoreFront: false,
                            showBrandFilter: false,
                            activeStoreFrontLink: false,
                            name: 'Autos',
                            children: [],
                            masterCategoryId: 0
                        }
                    ],
                    masterCategoryId: 0
                },
                {
                    isActive: true,
                    score: 0,
                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                    hasChildren: false,
                    title: 'SuperCat5',
                    fatherCategoryId: 0,
                    id: 27,
                    showInStoreFront: false,
                    showBrandFilter: false,
                    activeStoreFrontLink: false,
                    name: 'SuperCat5',
                    numberChildren: 0,
                    masterCategoryId: 0
                },
                {
                    isActive: true,
                    score: 0,
                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                    hasChildren: false,
                    title: 'Motocicletas',
                    fatherCategoryId: 0,
                    id: 28,
                    showInStoreFront: false,
                    showBrandFilter: false,
                    activeStoreFrontLink: false,
                    name: 'Motocicletas',
                    numberChildren: 0,
                    masterCategoryId: 0
                },
                {
                    isActive: true,
                    score: 0,
                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                    hasChildren: false,
                    title: 'Motos',
                    fatherCategoryId: 0,
                    id: 29,
                    showInStoreFront: false,
                    showBrandFilter: false,
                    activeStoreFrontLink: false,
                    name: 'Motos',
                    numberChildren: 0,
                    masterCategoryId: 0
                },
                {
                    isActive: true,
                    score: 0,
                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                    hasChildren: false,
                    title: 'Juegos',
                    fatherCategoryId: 0,
                    id: 30,
                    showInStoreFront: false,
                    showBrandFilter: false,
                    activeStoreFrontLink: false,
                    name: 'Juegos',
                    numberChildren: 0,
                    masterCategoryId: 0
                },
                {
                    isActive: true,
                    score: 0,
                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                    hasChildren: false,
                    title: 'Videos',
                    fatherCategoryId: 0,
                    id: 31,
                    showInStoreFront: false,
                    showBrandFilter: false,
                    activeStoreFrontLink: false,
                    name: 'Videos',
                    numberChildren: 0,
                    masterCategoryId: 0
                },
                {
                    isActive: true,
                    score: 0,
                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                    hasChildren: false,
                    title: 'Camas',
                    fatherCategoryId: 0,
                    id: 32,
                    showInStoreFront: false,
                    showBrandFilter: false,
                    activeStoreFrontLink: false,
                    name: 'Camas',
                    numberChildren: 0,
                    masterCategoryId: 0
                },
                {
                    isActive: true,
                    score: 0,
                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                    hasChildren: false,
                    title: 'Videojuegos',
                    fatherCategoryId: 0,
                    id: 33,
                    showInStoreFront: false,
                    showBrandFilter: false,
                    activeStoreFrontLink: false,
                    name: 'Videojuegos',
                    numberChildren: 0,
                    masterCategoryId: 0
                },
                {
                    isActive: true,
                    score: 0,
                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                    hasChildren: false,
                    title: 'Videojuegos1',
                    fatherCategoryId: 0,
                    id: 34,
                    showInStoreFront: false,
                    showBrandFilter: false,
                    activeStoreFrontLink: false,
                    name: 'Videojuegos1',
                    numberChildren: 0,
                    masterCategoryId: 0
                },
                {
                    isActive: true,
                    score: 0,
                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                    hasChildren: false,
                    title: 'CuatriMotos',
                    fatherCategoryId: 0,
                    id: 35,
                    showInStoreFront: false,
                    showBrandFilter: false,
                    activeStoreFrontLink: false,
                    name: 'CuatriMotos',
                    numberChildren: 0,
                    masterCategoryId: 0
                },
                {
                    isActive: true,
                    score: 0,
                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                    hasChildren: false,
                    title: 'Computadoras',
                    fatherCategoryId: 0,
                    id: 36,
                    showInStoreFront: false,
                    showBrandFilter: false,
                    activeStoreFrontLink: false,
                    name: 'Computadoras',
                    numberChildren: 0,
                    masterCategoryId: 0
                },
                {
                    isActive: true,
                    score: 0,
                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                    hasChildren: false,
                    title: 'NuevaCatX01',
                    fatherCategoryId: 0,
                    id: 37,
                    showInStoreFront: false,
                    showBrandFilter: false,
                    activeStoreFrontLink: false,
                    name: 'NuevaCatX01',
                    numberChildren: 0,
                    masterCategoryId: 0
                },
                {
                    isActive: true,
                    score: 0,
                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                    hasChildren: false,
                    title: 'SuperCat6',
                    fatherCategoryId: 0,
                    id: 38,
                    showInStoreFront: false,
                    showBrandFilter: false,
                    activeStoreFrontLink: false,
                    name: 'SuperCat6',
                    numberChildren: 0,
                    masterCategoryId: 0
                },
                {
                    isActive: true,
                    score: 0,
                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                    hasChildren: false,
                    title: 'Caseteras',
                    fatherCategoryId: 0,
                    id: 39,
                    showInStoreFront: false,
                    showBrandFilter: false,
                    activeStoreFrontLink: false,
                    name: 'Caseteras',
                    numberChildren: 0,
                    masterCategoryId: 0
                },
                {
                    isActive: true,
                    score: 0,
                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                    hasChildren: false,
                    title: 'Aspiradoras',
                    fatherCategoryId: 0,
                    id: 40,
                    showInStoreFront: false,
                    showBrandFilter: false,
                    activeStoreFrontLink: false,
                    name: 'Aspiradoras',
                    numberChildren: 0,
                    masterCategoryId: 0
                },
                {
                    isActive: true,
                    score: 0,
                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                    hasChildren: false,
                    title: 'Category multicatalog 2809_1',
                    fatherCategoryId: 0,
                    description: 'Category multicatalog 2809_1',
                    id: 41,
                    showInStoreFront: false,
                    showBrandFilter: true,
                    activeStoreFrontLink: true,
                    name: 'Category multicatalog 2809_1',
                    numberChildren: 0,
                    masterCategoryId: 0
                },
                {
                    isActive: true,
                    score: 0,
                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                    hasChildren: false,
                    title: 'Category multicatalog 2809_2',
                    fatherCategoryId: 0,
                    description: 'Category multicatalog 2809_2',
                    id: 42,
                    showInStoreFront: false,
                    showBrandFilter: true,
                    activeStoreFrontLink: true,
                    name: 'Category multicatalog 2809_2',
                    numberChildren: 0,
                    masterCategoryId: 0
                },
                {
                    isActive: true,
                    score: 0,
                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                    hasChildren: false,
                    title: 'Category multicatalog 2809_3',
                    fatherCategoryId: 0,
                    description: 'Category multicatalog 2809_3',
                    id: 43,
                    showInStoreFront: false,
                    showBrandFilter: true,
                    activeStoreFrontLink: true,
                    name: 'Category multicatalog 2809_3',
                    numberChildren: 0,
                    masterCategoryId: 0
                },
                {
                    isActive: true,
                    score: 0,
                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                    hasChildren: false,
                    title: 'Category multicatalog 2809_4',
                    fatherCategoryId: 0,
                    description: 'Category multicatalog 2809_4',
                    id: 45,
                    showInStoreFront: false,
                    showBrandFilter: true,
                    activeStoreFrontLink: true,
                    name: 'Category multicatalog 2809_4',
                    numberChildren: 0,
                    masterCategoryId: 0
                },
                {
                    isActive: true,
                    score: 0,
                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                    hasChildren: false,
                    title: 'Computadoras Gamer',
                    fatherCategoryId: 0,
                    id: 46,
                    showInStoreFront: false,
                    showBrandFilter: false,
                    activeStoreFrontLink: false,
                    name: 'Computadoras Gamer',
                    numberChildren: 0,
                    masterCategoryId: 0
                },
                {
                    isActive: true,
                    score: 0,
                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                    hasChildren: false,
                    title: 'Focos',
                    fatherCategoryId: 0,
                    id: 47,
                    showInStoreFront: false,
                    showBrandFilter: false,
                    activeStoreFrontLink: false,
                    name: 'Focos',
                    numberChildren: 0,
                    masterCategoryId: 0
                },
                {
                    isActive: true,
                    score: 0,
                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                    hasChildren: false,
                    title: 'MasterCategory',
                    fatherCategoryId: 0,
                    id: 48,
                    showInStoreFront: false,
                    showBrandFilter: false,
                    activeStoreFrontLink: false,
                    name: 'MasterCategory',
                    numberChildren: 0,
                    masterCategoryId: 0
                },
                {
                    isActive: true,
                    score: 0,
                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                    hasChildren: false,
                    title: 'MasterCategory01',
                    fatherCategoryId: 0,
                    id: 49,
                    showInStoreFront: false,
                    showBrandFilter: false,
                    activeStoreFrontLink: false,
                    name: 'MasterCategory01',
                    numberChildren: 0,
                    masterCategoryId: 0
                },
                {
                    isActive: true,
                    score: 0,
                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                    hasChildren: false,
                    title: 'MasterCategory02',
                    fatherCategoryId: 0,
                    id: 50,
                    showInStoreFront: false,
                    showBrandFilter: false,
                    activeStoreFrontLink: false,
                    name: 'MasterCategory02',
                    numberChildren: 0,
                    masterCategoryId: 0
                },
                {
                    isActive: true,
                    score: 0,
                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                    hasChildren: false,
                    title: 'MasterCategory03',
                    fatherCategoryId: 0,
                    id: 51,
                    showInStoreFront: false,
                    showBrandFilter: false,
                    activeStoreFrontLink: false,
                    name: 'MasterCategory03',
                    numberChildren: 0,
                    masterCategoryId: 0
                },
                {
                    isActive: true,
                    score: 0,
                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                    hasChildren: false,
                    title: 'MasterCategory04',
                    fatherCategoryId: 0,
                    id: 52,
                    showInStoreFront: false,
                    showBrandFilter: false,
                    activeStoreFrontLink: false,
                    name: 'MasterCategory04',
                    numberChildren: 0,
                    masterCategoryId: 0
                },
                {
                    isActive: true,
                    score: 0,
                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                    hasChildren: false,
                    title: 'MasterCategory05',
                    fatherCategoryId: 0,
                    id: 53,
                    showInStoreFront: false,
                    showBrandFilter: false,
                    activeStoreFrontLink: false,
                    name: 'MasterCategory05',
                    numberChildren: 0,
                    masterCategoryId: 0
                },
                {
                    isActive: true,
                    score: 0,
                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                    hasChildren: false,
                    title: 'MasterCategory06',
                    fatherCategoryId: 0,
                    id: 54,
                    showInStoreFront: false,
                    showBrandFilter: false,
                    activeStoreFrontLink: false,
                    name: 'MasterCategory06',
                    numberChildren: 0,
                    masterCategoryId: 0
                },
                {
                    isActive: true,
                    score: 0,
                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                    hasChildren: false,
                    title: 'MasterCategory07',
                    fatherCategoryId: 0,
                    id: 55,
                    showInStoreFront: false,
                    showBrandFilter: false,
                    activeStoreFrontLink: false,
                    name: 'MasterCategory07',
                    numberChildren: 0,
                    masterCategoryId: 0
                },
                {
                    isActive: true,
                    score: 0,
                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                    hasChildren: false,
                    title: 'MasterCategory08',
                    fatherCategoryId: 0,
                    id: 56,
                    showInStoreFront: false,
                    showBrandFilter: false,
                    activeStoreFrontLink: false,
                    name: 'MasterCategory08',
                    numberChildren: 0,
                    masterCategoryId: 0
                },
                {
                    isActive: true,
                    score: 0,
                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                    hasChildren: false,
                    title: 'SuperCategory01',
                    fatherCategoryId: 0,
                    id: 57,
                    showInStoreFront: false,
                    showBrandFilter: false,
                    activeStoreFrontLink: false,
                    name: 'SuperCategory01',
                    numberChildren: 0,
                    masterCategoryId: 0
                },
                {
                    isActive: true,
                    score: 0,
                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                    hasChildren: false,
                    title: 'SuperCat01',
                    fatherCategoryId: 0,
                    id: 58,
                    showInStoreFront: false,
                    showBrandFilter: false,
                    activeStoreFrontLink: false,
                    name: 'SuperCat01',
                    numberChildren: 0,
                    masterCategoryId: 0
                },
                {
                    isActive: true,
                    score: 0,
                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                    hasChildren: false,
                    title: 'SuperCat02',
                    fatherCategoryId: 0,
                    id: 59,
                    showInStoreFront: false,
                    showBrandFilter: false,
                    activeStoreFrontLink: false,
                    name: 'SuperCat02',
                    numberChildren: 0,
                    masterCategoryId: 0
                },
                {
                    isActive: true,
                    score: 0,
                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                    hasChildren: false,
                    title: 'SuperCat03',
                    fatherCategoryId: 0,
                    id: 60,
                    showInStoreFront: false,
                    showBrandFilter: false,
                    activeStoreFrontLink: false,
                    name: 'SuperCat03',
                    numberChildren: 0,
                    masterCategoryId: 0
                },
                {
                    isActive: true,
                    score: 0,
                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                    hasChildren: false,
                    title: 'Categoria Padre Test Mons',
                    fatherCategoryId: 0,
                    id: 63,
                    showInStoreFront: false,
                    showBrandFilter: false,
                    activeStoreFrontLink: false,
                    name: 'Categoria Padre Test Mons',
                    numberChildren: 0,
                    masterCategoryId: 0
                },
                {
                    isActive: true,
                    score: 0,
                    stockKeepingUnitSelectionMode: 'SPECIFICATION',
                    hasChildren: false,
                    title: 'Categoria Padre Monst',
                    fatherCategoryId: 0,
                    id: 64,
                    showInStoreFront: false,
                    showBrandFilter: false,
                    activeStoreFrontLink: false,
                    name: 'Categoria Padre Monst',
                    numberChildren: 0,
                    masterCategoryId: 0
                }
            ]
        }
    ]
};

export default getCategoriesServiceMock;
